import React, { Component, PureComponent, Fragment } from 'react';
import axios from 'axios';
import harcodedData, {pockets, lightData} from './harcoded-data';
import Vimeo from '@u-wave/react-vimeo';
import HTML5Backend from 'react-dnd-html5-backend'
import TouchBackend from 'react-dnd-touch-backend'
import { DragDropContext } from 'react-dnd'
import MultiBackend from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/lib/HTML5toTouch';
import ToggleButton from 'react-toggle-button';

import update from 'immutability-helper';
import './styles/main.css';
import Client from 'shopify-buy';
import DragProduct from './components/DragProduct';
import SelectProduct from './components/SelectProduct';

import DropProduct from './components/DropProduct';
import DropToRemove from './components/DropToRemove';
import ActiveProduct from './components/ActiveProduct';
import ActiveCord from './components/ActiveCord';
import Sidebar from './components/Sidebar';
import FooterLinks from './components/FooterLinks';
import Header from './components/Header';
import Modal from './components/Modal';
import ModalBeforeCheckout from './components/Modal/BeforeCheckout';
import InitialBaseplateSelection from './components/InitialBaseplateSelection'

import baseplateBlue from './images/baseplates/blue.jpg';
import baseplateGrey from './images/baseplates/grey.jpg';
import baseplateBlack from './images/baseplates/black.jpg';
import baseplateBeige from './images/baseplates/beige.jpg';

import backgroundTexture from './images/background-texture.jpg';
import loadingDark from './images/loading-dark.svg';
import information from './images/information.svg';
import check from './images/check.svg'; 
import logo from './images/logo.png';
import logoMobile from './images/logo-mobile.png';
import arrowTop from './images/top-arrow.svg';
import arrowBottom from './images/bottom-arrow.svg';
import washersScrewSet from './images/washers-screws.png';
import adhesiveScrewSet4 from './images/adhesive-screw-set.png';
import adhesiveScrewSet6 from './images/adhesive-screw-set-6.png';
import plus from './images/plus.svg';
import checkLight from './images/check-white.svg';
import checkGreen from './images/check-green.svg';
import Loading from './images/loading.gif';
import pocketS from "./images/wireframe/pocket-s.png";
import pocketM from "./images/wireframe/pocket-m.png";
import pocketB from "./images/wireframe/pocket-b.png";
import pocketL from "./images/wireframe/pocket-l.png";
import pocketXL from "./images/wireframe/pocket-xl.png";
import pocketXXL from "./images/wireframe/pocket-xxl.png";
import outbag55  from "./images/wireframe/outbag-5-5.png";
import outbag95  from "./images/wireframe/outbag-9-5.png";
import laundrygg  from "./images/wireframe/laundrygg.png";

import baseplateExtended from "./images/extended-baseplate.svg"
import chat from "./images/chat.svg"
import steps from "./images/steps.png"

import singleHook from "./images/wireframe/single-hook.png";
import doubleHook from "./images/wireframe/double-hook.png";
import loop from "./images/wireframe/loop.png";
import paperRollHolder from "./images/wireframe/paper-roll-holder.png";
import { drop } from 'lodash';

const data = {
  english: {
    string_0: 'RYGG VISUALIZER',
    string_1: 'Yeah, welcome to our RYGG customizer',
    string_2: 'Here is a little clip of how it works:',
    string_3: 'Please note that colors may appear slightly different from the final product because every monitor is calibrated differently. The dimensions of the modules (Pockets, Loops, Cords) may also slightly vary',
    string_4: 'This tool can help you',
    string_5: 'Getting a better imagination of how your customized RYGG will look like',
    string_6: 'Getting how many modules can be put on your customized RYGG and where',
    string_7: 'Getting a better understanding of how your RYGG will work for you the best',
    string_8: 'If you need additional modules please visit our Single Modules (opens new tab) section',
    string_9: 'LET’S START',
    string_10: 'WORK BENCH',
    string_11: 'YOUR RYGG',
    string_12: 'Price',
    string_13: 'German added value tax (16%) included.',
    string_14: 'Shipping costs will be applied at checkout',
    string_15: 'VANTALE ONLINE STORE',
    string_16: 'PRIVACY POLICY',
    string_17: 'IMPRINT',
    string_18: 'SHIPPING AND TIMES',
    string_19: 'PRESS KIT',
    string_20: 'Utensilo made with Love',
    string_21: 'Choose your baseplate',
    string_22: '42x58 cm (Single seat)',
    string_23: '77x58 cm (Double seat)',
    string_24: 'Seat RYGG Baseplates',
    string_25: 'Wall RYGG Baseplates',
    string_26: '68x40 cm (Kompanja)',
    string_27: 'https://vantale-store.de',
    string_28: 'https://vantale-store.de/pages/shipping',
    string_29: 'https://vantale-store.de',
    string_30: 'https://vantale-store.de/pages/press-kit',
    string_31: 'FAQ',
    string_32: 'https://vantale-store.de/pages/faq',
    string_33: 'Adhesive Screw-Set',
    string_34: 'Changes you\'ve made will not be saved',
    string_35: 'Do you need a mounting solution for your',
    string_36: 'With the following items your RYGG can be attached to the wall.',
    string_37: 'Washers and Screws',
    string_38: 'Learn more about this mounting option here',
    string_39: 'Adhesive Screw-Set',
    string_40: 'Amount',
    string_41: 'Fitting to the selection of your Baseplate',
    string_42: 'ADD TO BASKET',
    string_43: 'In Basket',
    string_44: 'Price:',
    string_45: 'Continue',
    string_46: 'Wall Baseplate',
    string_47: 'Now you know which modules you need to add to your cart at www.vantale.de. Next step leads to our...',
    string_48: 'Link Opens in new Tab',
    string_49: 'In the next step you can design your Modules with the POCKET MODIFIER or choose one of our standard colors.',
    string_50: 'Ready?',
    string_51: 'Fastening Cord',
    string_52: 'Step 1 of 3: Baseplate Set-up',
    string_53: 'Attention, remember these  modules, you need to add them to the shopping cart in step 3.',
    string_54: 'Drag the Modules onto the Baseplate. Drag them back here to delete them from the Baseplate',
    string_55: 'Step 2: Choose Colours',
  },

  german: {
    string_0: 'RYGG VISUALIZER',
    string_1: 'Hi, willkommen beim RYGG-Konfigurator',
    string_2: 'Hier siehst du, wie der Konfigurator funktioniert:',
    string_3: 'Bitte beachte, dass die Farben leicht vom Endprodukt abweichen können, da jeder Monitor anders kalibriert ist. Die Abmessungen der Module (Pockets, Loops, Cords) können ebenfalls geringfügig variieren',
    string_4: 'Dieser Konfigurator hilft dir',
    string_5: 'Eine bessere Vorstellung davon zu erhalten, wie dein individuelles RYGG aussehen wird',
    string_6: 'Wieviele Module du wo auf dem RYGG platzieren kannst',
    string_7: 'Ein besseres Verständnis dafür zu bekommen, wie dein RYGG am besten für dich funktioniert',
    string_8: 'Wenn du zusätzliche Module benötigst, findest du hier alle einzelnen Produkte. (öffnet ein neues Tab).',
    string_9: 'LOS GEHT’S',
    string_10: 'WERKBANK',
    string_11: 'Dein RYGG',
    string_12: 'Preis',
    string_13: 'Inklusive deutscher Mehrwertsteuer von 16%',
    string_14: 'Versandkosten werden beim nächsten Schritt berechnet.',
    string_15: 'VANTALE ONLINE SHOP',
    string_16: 'DATENSCHUTZ',
    string_17: 'IMPRESSUM',
    string_18: 'VERSAND UND LIEFERZEITEN  ',
    string_19: 'PRESSEMATERIAL',
    string_20: 'Das Utensilo, mit <3 gemacht',
    string_21: 'Wähle deine RYGG Basisplatte',
    string_22: '42x58 cm (Single seat)',
    string_23: '77x58 cm (Double seat)',
    string_24: 'RYGG Basisplatten für den Autositz',
    string_25: 'RYGG Basisplatten für die Wand',
    string_26: '68x40 cm (Kompanja)',
    string_27: 'https://vantale.de',
    string_28: 'https://vantale.de/pages/versand-lieferzeiten-versandkosten',
    string_29: 'https://vantale.de',
    string_30: 'https://vantale.de/pages/presskitvantale',
    string_31: 'HÄUFIG GESTELLTE FRAGEN',
    string_32: 'https://vantale.de/pages/faq',
    string_33: 'Klebeschrauben – Wandmontage-Set',
    string_34: 'Changes you\'ve made will not be saved',
    string_35: 'Brauchst du noch eine Montagelösung für deine',
    string_36: 'Hiermit kannst du deine Basisplatte an der Wand befestigen',
    string_37: 'Unterlegscheibe und Schraube',
    string_38: 'Erfahre mehr darüber',
    string_39: 'Klebeschrauben-Set',
    string_40: 'Amount',
    string_41: 'Passt zu deiner Basisplatten-Auswahl',
    string_42: 'HINZUFÜGEN',
    string_43: 'Im Warenkorb',
    string_44: 'Preis:',
    string_45: 'Fortsetzen',
    string_46: 'Wand Basisplatte',
    string_47: 'Dann weißt du jetzt, was du alles in den Warenkorb legen musst. Als Nächstes geht es zum ...',
    string_48: '(Link öffnet in neuem Tab)',
    string_49: 'Hier kannst du Taschen in deiner eigenen Farbkombination erstellen, oder aus unseren Standardfarben wählen.',
    string_50: 'Fertig?',
    string_51: 'Befestigungskordeln',
    string_52: 'Schritt 1 von 3: Anordnung planen',
    string_53: 'Achtung, merke dir diese Module, du musst sie bei Schritt 3 in den Warenkorb legen.',
    string_54: 'Ziehe die Module auf die Basisplatte. Ziehe sie von der Basisplatte wieder hierher, um sie zu entfernen.',
    string_55: 'Schritt 2: Farben wählen'
  }
}

const dataPockets = [
  {
      "title": "Pocket S",
      "handle": "pocket-s",
      "image": pocketS,
      "price": "33.50",
      "willOccupyCells": 2,
      "id": 1,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/Hr=?:'
  },
  {
      "title": "Pocket M",
      "handle": "pocket-m",
      "image": pocketM,
      "price": "38.00",
      "willOccupyCells": 4,
      "id": 2,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/Hr=?'
  },

  {
      "title": "Pocket B",
      "handle": "pocket-b",
      "image": pocketB,
      "price": "42.00",
      "willOccupyCells": 2.2,
      "id": 3,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/Hr='
  },

  {
      "title": "Pocket L",
      "handle": "pocket-l",
      "image": pocketL,
      "price": "46.00",
      "willOccupyCells": 8,
      "id": 4,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/Hr'
  },

  {
      "title": "Pocket XL",
      "handle": "pocket-xl",
      "image": pocketXL,
      "price": "46.00",
      "willOccupyCells": 12,
      "id": 5,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/H'
  },

  {
      "title": "Pocket XXL",
      "handle": "pocket-xxl",
      "image": pocketXXL,
      "price": "46.00",
      "willOccupyCells": 16,
      "id": 6,
      "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe/'
  },

  {
    "title": "Outbag 5.5",
    "handle": "outbag-5-5",
    "image": outbag55,
    "price": "46.00",
    "willOccupyCells": 6,
    "id": 7,
    "variantId": 'Vtk{B%W(Gem{9aCi(SLA5BNe'
  },

  {
    "title": "Outbag 9.5",
    "handle": "outbag-9-5",
    "image": outbag95,
    "price": "46.00",
    "willOccupyCells": 12,
    "id": 8,
    "variantId": 'Vtk{B%W(Gem{9aCi(SLA5B'
  },

  {
    "title": "Laundrygg",
    "handle": "laundrygg",
    "image": laundrygg,
    "price": "46.00",
    "willOccupyCells": 18,
    "id": 9,
    "variantId": 'Vtk{B%W(Gem{9aCi(SLA'
  },

]

const dataHooks = [
  {
      "title": "Single Hook",
      "handle": "single-hook",
      "image": singleHook,
      "price": "33.50",
      "willOccupyCells": 1,
      "id": 1,
      "variantId": 'Vtk{B%W(Gem{9aCi(SL'
  },
  {
      "title": "Double Hook",
      "handle": "double-hook",
      "image": doubleHook,
      "price": "38.00",
      "willOccupyCells": 1,
      "id": 2,
      "variantId": 'Vtk{B%W(Gem{9aCi'
  },

  {
      "title": "Loop",
      "handle": "loop",
      "image": loop,
      "price": "42.00",
      "willOccupyCells": 1,
      "id": 3,
      "variantId": 'Vtk{B%W(Gem{9aC'
  },

  {
    "title": "Paper Roll Holder",
    "handle": "paper-roll-holder",
    "image": paperRollHolder,
    "price": "10.00",
    "willOccupyCells": 5,
    "id": 4,
    "variantId": 'Vtk{B%W(Gem{9a'
},



]

const client = Client.buildClient({
  domain: 'vantale.myshopify.com',
  storefrontAccessToken: 'b8247bed331abd94cc026a404d2fd0d3'
});


class App extends PureComponent {
  state = {
    activeInitialBaseplate: null,
    hasHaube: false,
    showBaseplateSelectionControls: true,
    activeLanguage: 'german',
    stringData : data.german,
    isCreator: false,
    generatedCode: '',
    lockMode: false,
    showTutoral: true,
    isOpen: false,
    checkoutLoading: false,
    cartProducts: [],
    cartTotalPrice: 0.00,
    canDelete: false, // Used when dragging baseplate item
    isDragging: false,  
    hoveringOverBaseplate: false,
    hoverCell: null,
    products: [],
    productsLoading: false,
    willOccupyCells: 0,
    isWallBaseplate: true,
    activeBaseplate: 0,
    activeCord: 0,
    activePocketSmall: 0,
    activePocketMedium: 0,
    activePocketBig: 0,
    activePocketBottle: 0,
    activePocketXL: 0,
    activeLoop: 0, // This is replaced by activeNylonLoop
    activeLoopType: 0, // This refers to actual type, not a variation.
    showBeforeCheckoutModal: false,
    activeNylonLoop: 0,
    activeAluLoop: 0,
    activeAluHook: 0,
    activeAluDoubleHook: 0,
    addWashersAndScrews: false,
    addAdhesiveScrewSet: false,
    draggingProduct: {},
    addedProducts: [],
    activePocketMode: 0,
    activeHookMode: 0,
    cells: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},
      {id: 13, drawPreview: false, available: true},
      {id: 14, drawPreview: false, available: true},
      {id: 15, drawPreview: false, available: true},
      {id: 16, drawPreview: false, available: true},
      {id: 17, drawPreview: false, available: true},
      {id: 18, drawPreview: false, available: true},
    ],

    cells_4x2: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
    ],

    cells_10x3: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},

      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},
      {id: 13, drawPreview: false, available: true},
      {id: 14, drawPreview: false, available: true},
      {id: 15, drawPreview: false, available: true},
      {id: 16, drawPreview: false, available: true},
      {id: 17, drawPreview: false, available: true},
      {id: 18, drawPreview: false, available: true},
      {id: 19, drawPreview: false, available: true},
      {id: 20, drawPreview: false, available: true},

      {id: 21, drawPreview: false, available: true},
      {id: 22, drawPreview: false, available: true},
      {id: 23, drawPreview: false, available: true},
      {id: 24, drawPreview: false, available: true},
      {id: 25, drawPreview: false, available: true},
      {id: 26, drawPreview: false, available: true},
      {id: 27, drawPreview: false, available: true},
      {id: 28, drawPreview: false, available: true},
      {id: 29, drawPreview: false, available: true},
      {id: 30, drawPreview: false, available: true},
    ],

    cells_10x2_KOMPANJA: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},

      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},
      {id: 13, drawPreview: false, available: true},
      {id: 14, drawPreview: false, available: true},
      {id: 15, drawPreview: false, available: true},
      {id: 16, drawPreview: false, available: true},
      {id: 17, drawPreview: false, available: true},
      {id: 18, drawPreview: false, available: true},
      {id: 19, drawPreview: false, available: true},
      {id: 20, drawPreview: false, available: true},
    ],

    cells_8x1: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
    ],

    cells_8x2: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},

      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},
      {id: 13, drawPreview: false, available: true},
      {id: 14, drawPreview: false, available: true},
      {id: 15, drawPreview: false, available: true},
      {id: 16, drawPreview: false, available: true},
    ],

    cells_6x2: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},
    ],

    cells_2x2: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
    ],

    cells_2x3: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
    ],

    cells_2x4: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
    ],

    cells_12x1: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},      
    ],

    cells_4x4: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},  
      {id: 13, drawPreview: false, available: true},
      {id: 14, drawPreview: false, available: true},
      {id: 15, drawPreview: false, available: true},
      {id: 16, drawPreview: false, available: true},  
    ],

    cells_4x3: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
      {id: 9, drawPreview: false, available: true},
      {id: 10, drawPreview: false, available: true},
      {id: 11, drawPreview: false, available: true},
      {id: 12, drawPreview: false, available: true},  
    ],

    cells_4x2: [
      {id: 1, drawPreview: false, available: true},
      {id: 2, drawPreview: false, available: true},
      {id: 3, drawPreview: false, available: true},
      {id: 4, drawPreview: false, available: true},
      {id: 5, drawPreview: false, available: true},
      {id: 6, drawPreview: false, available: true},
      {id: 7, drawPreview: false, available: true},
      {id: 8, drawPreview: false, available: true},
    ]
  };

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });

    if (!this.state.isOpen) {
      document.body.classList.add('modal-open')
    }

    else {
      document.body.classList.remove('modal-open');
    }
  }

  toggleBeforeCheckoutModal = () => {
    this.setState({
      showBeforeCheckoutModal: false
    });

    if (!this.state.showBeforeCheckoutModal) {
      document.body.classList.add('modal-open')
    }

    else {
      document.body.classList.remove('modal-open');
    }
  }

  _renderCells = (products) => {
    const { activeInitialBaseplate } = this.state;
    return products.map((product, id) => {
      return product.available ? (
        <DropProduct 
          id={id}
          key={product.id}
          addRenderedProductToState = {this._addRenderedProductToState}
          updateCellAvailability = {this._updateCellAvailability}
          calculatePreviewCells = {this._calculatePreviewCells} 
          dropToTheRightCell= {this._dropToTheRightCell}
          appState= {this.state}
          details={
            {
              id: 
                activeInitialBaseplate === '10x3' ? this.state.cells_10x3[id].id : 
                activeInitialBaseplate === '10x2_KOMPANJA' ? this.state.cells_10x2_KOMPANJA[id].id : 
                activeInitialBaseplate === '8x1' ? this.state.cells_8x1[id].id : 
                activeInitialBaseplate === '8x2' ? this.state.cells_8x2[id].id : 
                activeInitialBaseplate === '6x2' ? this.state.cells_6x2[id].id : 
                activeInitialBaseplate === '2x2' ? this.state.cells_2x2[id].id : 
                activeInitialBaseplate === '2x3' ? this.state.cells_2x3[id].id : 
                activeInitialBaseplate === '2x4' ? this.state.cells_2x4[id].id : 
                activeInitialBaseplate === '12x1' ? this.state.cells_12x1[id].id : 
                activeInitialBaseplate === '4x4' ? this.state.cells_4x4[id].id : 
                activeInitialBaseplate === '4x3' ? this.state.cells_4x3[id].id :
                activeInitialBaseplate === '4x2' ? this.state.cells_4x2[id].id :  
                this.state.cells[id].id, 
              available: 
                activeInitialBaseplate === '10x3' ? this.state.cells_10x3[id].available : 
                activeInitialBaseplate === '10x2_KOMPANJA' ? this.state.cells_10x2_KOMPANJA[id].available : 
                activeInitialBaseplate === '8x1' ? this.state.cells_8x1[id].available : 
                activeInitialBaseplate === '8x2' ? this.state.cells_8x2[id].available : 
                activeInitialBaseplate === '6x2' ? this.state.cells_6x2[id].available : 
                activeInitialBaseplate === '2x2' ? this.state.cells_2x2[id].available : 
                activeInitialBaseplate === '2x3' ? this.state.cells_2x3[id].available : 
                activeInitialBaseplate === '2x4' ? this.state.cells_2x4[id].available : 
                activeInitialBaseplate === '12x1' ? this.state.cells_12x1[id].available : 
                activeInitialBaseplate === '4x4' ? this.state.cells_4x4[id].available : 
                activeInitialBaseplate === '4x3' ? this.state.cells_4x3[id].available :
                activeInitialBaseplate === '4x2' ? this.state.cells_4x2[id].available :  
                this.state.cells[id].available, 
              drawPreview: 
                activeInitialBaseplate === '10x3' ? this.state.cells_10x3[id].drawPreview : 
                activeInitialBaseplate === '10x2_KOMPANJA' ? this.state.cells_10x2_KOMPANJA[id].drawPreview :
                activeInitialBaseplate === '8x1' ? this.state.cells_8x1[id].drawPreview : 
                activeInitialBaseplate === '8x2' ? this.state.cells_8x2[id].drawPreview : 
                activeInitialBaseplate === '6x2' ? this.state.cells_6x2[id].drawPreview : 
                activeInitialBaseplate === '2x2' ? this.state.cells_2x2[id].drawPreview : 
                activeInitialBaseplate === '2x3' ? this.state.cells_2x3[id].drawPreview : 
                activeInitialBaseplate === '2x4' ? this.state.cells_2x4[id].drawPreview : 
                activeInitialBaseplate === '12x1' ? this.state.cells_12x1[id].drawPreview : 
                activeInitialBaseplate === '4x4' ? this.state.cells_4x4[id].drawPreview :
                activeInitialBaseplate === '4x3' ? this.state.cells_4x3[id].drawPreview :
                activeInitialBaseplate === '4x2' ? this.state.cells_4x2[id].drawPreview :
                this.state.cells[id].drawPreview}
            }
          />
      ): null
    })
  }
  
  _resetDrawingCells = () => {
    this.setState(prevState => {
      const newItems = [...prevState.cells];
      newItems[0].drawPreview = false;
      newItems[1].drawPreview = false;
      newItems[2].drawPreview = false;
      newItems[3].drawPreview = false;
      newItems[4].drawPreview = false;
      newItems[5].drawPreview = false;
      newItems[6].drawPreview = false;
      newItems[7].drawPreview = false;
      newItems[8].drawPreview = false;
      newItems[9].drawPreview = false;
      newItems[10].drawPreview = false;
      newItems[11].drawPreview = false;
      newItems[12].drawPreview = false;
      newItems[13].drawPreview = false;
      newItems[14].drawPreview = false;
      newItems[15].drawPreview = false;
      newItems[16].drawPreview = false;
      newItems[17].drawPreview = false;

      return {
        items: newItems,
        willOccupyCells: 0
      };
    })
  }

  _isDragging = (isDragging, willOccupyCells) => {    
    this.setState({
      isDragging: isDragging,
      willOccupyCells: willOccupyCells
    })

    if (!isDragging) {
      this._resetDrawingCells();
      this.setState({
        hoverCell: null
      })
    }
  }

  _canDelete = (value) => {
    this.setState({
      canDelete: value
    })
  }

  _initializeProduct() {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type');

    if (type === 'preconfigured') {
      // take the original json query
      const originalJson = JSON.parse(urlParams.get('query'));
      const activeInitialBaseplate = JSON.parse(JSON.stringify(urlParams.get('activeInitialBaseplate')));
      console.log('c', activeInitialBaseplate);
      const activeBaseplate = parseInt(urlParams.get('activeBaseplate'));
      const isWallBaseplate = urlParams.get('isWallBaseplate') === 'true';

      const activeCord = parseInt(urlParams.get('activeCord'));
      // declare the prepared variable. Prepared means object divided with '&' sign in between
      // This is used for additional dividing, and putting into an array
      let originalJsonPrepared = '';

      originalJsonPrepared += originalJson.map((product, id) => {
        let productString = JSON.stringify(product) + (id === originalJson.length - 1 ? '' : '&');
        return productString
      });

      const arrStr = originalJsonPrepared.split(/[&]/);
      let finalArray = []
      let temporaryCart = [];
      let temporaryCartTotalPrice = 0.00

      for (var i = 0; i < arrStr.length; i++) {
        // Make sure that the json object is valid. In some cases, it would automatically get ',' 
        // in between the objects. Make sure that don't happen
        let toPush = (arrStr[i].charAt(0) === ',' ? arrStr[i].substring(1) : arrStr[i]);
        // Push it to rendered array
        finalArray.push(JSON.parse(toPush));
        temporaryCart.push({
          variantId: JSON.parse(toPush).variantId,
          quantity: 1
        })
        temporaryCartTotalPrice += parseFloat(JSON.parse(toPush).price)
      }

      // Render all the added products
      this.setState( prevState => {
        return {
          activeInitialBaseplate: activeInitialBaseplate ? activeInitialBaseplate : '6x3',
          activeBaseplate: activeBaseplate,
          activeCord: activeCord,  
          addedProducts: finalArray,
          cartProducts: temporaryCart,
          cartTotalPrice: prevState.cartTotalPrice += temporaryCartTotalPrice,
          isWallBaseplate: isWallBaseplate
        }
      }, () => {
        this._disableAllCells();
      })      
    }

    else if (type === 'kompanja') {
      this.setState({
        activeInitialBaseplate: '10x2_KOMPANJA',
        showBaseplateSelectionControls: false,
        activeBaseplate: 2,
      })
    }

    else if (type === 'creator') {
      this.setState({
        isCreator: true
      })
    }

    else if (type === 'baseplate') {
      // http://customize.vantale.de/?type=baseplate&layout=2x4
      const activeInitialBaseplate = JSON.parse(JSON.stringify(urlParams.get('layout')));
      const hasHaube = JSON.parse(JSON.stringify(urlParams.get('haube')));

      if (activeInitialBaseplate === '10x3_SEAT') {
        this.setState({
          activeInitialBaseplate: '10x3',
          isWallBaseplate: false
        })
      }

      else if (activeInitialBaseplate === '6x3_SEAT') {
        this.setState({
          activeInitialBaseplate: '6x3',
          isWallBaseplate: false
        })
      }
      else {
        this.setState({
          activeInitialBaseplate: activeInitialBaseplate,
          hasHaube: hasHaube
        })
      }
    }

    else {
      this.setState({
        activeInitialBaseplate: '6x3',
      })
    }
  }

  componentWillUpdate() {
    this.setState(prevState => {
      return({
        stringData: prevState.activeLanguage === 'german' ? data.german : data.english
      })
    })
  }

  componentWillMount() {
    let _this = this;
    axios.get('http://ip-api.com/json')
    .then(function (response) {
      const {countryCode} = response.data
      // handle success
      _this.setState({
        activeLanguage: countryCode === 'AT' || countryCode === 'AUT' || countryCode === 'CH' || countryCode === 'CHE' || countryCode === 'DE' || countryCode === 'DEU' ? 'german' : 'english' 
      })
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  })
  .then(function () {
    // always executed
  });
  }

	componentDidMount() {    
    this._initializeProduct()

    // Always scroll to the top of the page on each page load
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }

    //If the local storage is available
    if (typeof(Storage) !== "undefined") {
      // If user is coming first time
      // Make sure he's registered as a 1 time visit and
      // display the modal
      if (isNaN(localStorage.timeVisiting)) {
        localStorage.timeVisiting = 0;
        this.toggleModal();
      }

      // If a user is coming more then first time
      // show modal only on second/third visit
      else {
        localStorage.timeVisiting = Number(localStorage.timeVisiting) + 1;
        if (localStorage.timeVisiting <= 2) {
          this.toggleModal();
        }
      }
    } else {
      // Sorry! No Web Storage support..
    }
    // localStorage.clear()
  }

  _renderAPIDraggableProducts (products) {
    const hideLargerPockets = this.state.activeInitialBaseplate === '2x4' || this.state.activeInitialBaseplate === '2x3' || this.state.activeInitialBaseplate === '2x2';
    const active2xXBaseplates = this.state.activeInitialBaseplate === '2x4' || this.state.activeInitialBaseplate === '2x3' || this.state.activeInitialBaseplate === '2x2';
    const active4xXBaseplates = this.state.activeInitialBaseplate === '4x4' || this.state.activeInitialBaseplate === '4x3' || this.state.activeInitialBaseplate === '4x2';
    const active6xXBaseplates = this.state.activeInitialBaseplate === '6x3' || this.state.activeInitialBaseplate === '6x2';
    // If products are loaded
    // if (products.length > 0) {
    if (true) {
      const {
        activePocketSmall, 
        activePocketMedium, 
        activePocketBig,
        activePocketBottle,
        activeLoop, 
        activeNylonLoop, 
        activeAluLoop, 
        activeAluHook, 
        activeAluDoubleHook,
        activePocketMode,
        activePocketXL,
        activeHookMode
      } = this.state;

      // TODO: !hideLargerPockets 
      return (
        <div className="draggable">
          <div className="title">
            <h5>Pockets</h5>
            <p className="disclaimer">{this.state.stringData.string_54}</p>
          </div>

          {dataPockets.map((item) => {      
            
            return activePocketMode === item.id - 1 && (
              <DragProduct 
                disabled={
                  item.handle === 'pocket-m' ? active2xXBaseplates :
                  item.handle === 'pocket-l' ? active2xXBaseplates :
                  item.handle === 'pocket-xl' ? active2xXBaseplates || active4xXBaseplates :
                  item.handle === 'outbag-5-5' ? active2xXBaseplates || active4xXBaseplates :
                  item.handle === 'outbag-9-5' ? active2xXBaseplates || active4xXBaseplates :
                  item.handle === 'laundrygg' ? active2xXBaseplates || active4xXBaseplates :
                  item.handle === 'pocket-xxl' ? active2xXBaseplates || active4xXBaseplates || active6xXBaseplates : false
                }
                isPocket={true}
                isLoop={false}
                appState={this.state}
                isDragging = {this._isDragging}
                addDraggingProductToState={this._addDraggingProductToState} 
                details={{id: 2, productDetails: item}} 
                type={item.handle}
                imgSrc={item.image} 
                title={item.title}
                renderActiveSelectable={this._renderActiveSelectable}
            />
            )
          })}
          
          <div className="line"></div>

          <div className="title">
            <h5>Hooks/Loops/Helpers</h5>
          </div>
          
          {dataHooks.map((item) => {
            return activeHookMode === item.id - 1 && (
              <DragProduct 
                disabled={ 
                  item.handle === 'paper-roll-holder' ? active2xXBaseplates || active4xXBaseplates : false
                }
                isPocket={true}
                isLoop={true}
                appState={this.state}
                isDragging = {this._isDragging}
                addDraggingProductToState={this._addDraggingProductToState} 
                details={{id: 2, productDetails: item}} 
                type={item.handle}
                imgSrc={item.image} 
                title={item.title}
                isPocketBig={false}
                renderActiveSelectable={this._renderActiveSelectable}
                activePocketSmall={this.state.activePocketSmall}
                activePocketMedium={this.state.activePocketMedium}
                activePocketBig={this.state.activePocketBig}
            />
            )
          })}
        </div>
      )
    }
  }

  _renderAPISelectableProducts(products) {
    const {activeInitialBaseplate, showBaseplateSelectionControls, isWallBaseplate} = this.state;
    return products.map((product, id) => {

      return (
      product.handle === 'baseplate' && this.state.showBaseplateSelectionControls) ||
      (product.handle === 'fastening-cord' && this.state.activeInitialBaseplate !== '10x2_KOMPANJA')
       ? (
        
        <div key={id} className={`${product.handle === 'fastening-cord' && isWallBaseplate ? 'hidden':''}`}>         
          <SelectProduct 
            type={product.handle}
            title={product.title}
            renderActiveSelectable={this._renderActiveSelectable}
            activeBaseplate={this.state.activeBaseplate}
            activeCord={this.state.activeCord}
            />

          <div className="line mb-2"></div>
        </div>
      ) : null
    })
  }

  _renderAddedProducts(products) {
    return products.map((product, id) => {
      return(
        <ActiveProduct 
          appState={this.state}
          addDraggingProductToState={this._addDraggingProductToState} 
          canDelete={this._canDelete}
          details={{id: id, productDetails: product}} 
          key={id}
          startCell={product.startCell}
          endCell={product.endCell}
          imgSrc={product.imgSrc} 
          type={product.type}
        />
      )
    })
  }

  _addDraggingProductToState = (product) => {
    console.log(product)
    this.setState({
      draggingProduct: product
    })
  }
  // Calculate exact coordinates where to put the product based on drop cell
  // and product type
  _dropToTheRightCell = (product, droppedToCell, willOccupyCells) => {
    const {activeInitialBaseplate} = this.state;

    // 2xX baseplates seem to work with our old default implementation because they accept on <= 2 cells in width
    // The same for all activeInitialBaseplate values
    // Hooks and 1 cell stuff
    if (willOccupyCells === 1) {
      this._addRenderedProductToState(product, droppedToCell, willOccupyCells);
    }

    // The same for all activeInitialBaseplate values
    // Small pocket
    else if (willOccupyCells === 2) {
      // If the dropping cell is even
      if (droppedToCell % 2 === 0) {
        // Drop to that cell - 1 index, and occupy both of them
        this._addRenderedProductToState(product, droppedToCell - 1, willOccupyCells);
      }

      else {
        this._addRenderedProductToState(product, droppedToCell, willOccupyCells);
      }
    }

    // Medium pocket
    else if (willOccupyCells === 4) {

      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 7 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        // Row 2
        if (droppedToCell >= 11 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell >= 15 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }

        else if (droppedToCell >= 17 && droppedToCell <= 20) {
          this._addRenderedProductToState(product, 17, willOccupyCells)
        }

        // Row 3
        if (droppedToCell >= 21 && droppedToCell <= 22) {
          this._addRenderedProductToState(product, 21, willOccupyCells)
        }

        else if (droppedToCell >= 23 && droppedToCell <= 24) {
          this._addRenderedProductToState(product, 23, willOccupyCells)
        }

        else if (droppedToCell >= 25 && droppedToCell <= 26) {
          this._addRenderedProductToState(product, 25, willOccupyCells)
        }

        else if (droppedToCell >= 27 && droppedToCell <= 30) {
          this._addRenderedProductToState(product, 27, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 7 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        // Row 2
        if (droppedToCell >= 11 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell >= 15 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }

        else if (droppedToCell >= 17 && droppedToCell <= 20) {
          this._addRenderedProductToState(product, 17, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 9 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell >= 11 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }
  
        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      // Fallback to our default baseplate
      else {
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }
  
        else if (droppedToCell >= 3 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }
  
        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }


  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
  
        else if (droppedToCell >= 13 && droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
  
        else if (droppedToCell >= 15 && droppedToCell <= 18) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }
      }
    }

    else if (willOccupyCells === 5) {

      if (activeInitialBaseplate === '10x3') {
        if (droppedToCell >= 1 && droppedToCell <= 5) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 6 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 6, willOccupyCells)
        }

        else if (droppedToCell >= 11 && droppedToCell <= 15) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 16 && droppedToCell <= 20) {
          this._addRenderedProductToState(product, 16, willOccupyCells)
        }

        else if (droppedToCell >= 21 && droppedToCell <= 25) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 26 && droppedToCell <= 30) {
          this._addRenderedProductToState(product, 26, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        if (droppedToCell >= 1 && droppedToCell <= 5) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 6 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 6, willOccupyCells)
        }

        else if (droppedToCell >= 11 && droppedToCell <= 15) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 16 && droppedToCell <= 20) {
          this._addRenderedProductToState(product, 16, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (droppedToCell >= 1 && droppedToCell <= 3) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 4 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 4, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (droppedToCell >= 1 && droppedToCell <= 3) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 4 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 4, willOccupyCells)
        }

        else if (droppedToCell >= 9 && droppedToCell <= 11) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 12 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 12, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (droppedToCell === 1) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 2 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 2, willOccupyCells)
        }

        else if (droppedToCell === 7) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 8 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 8, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        if (droppedToCell >= 1 && droppedToCell <= 7) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 8 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 8, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      // Fallback to our default baseplate
      else {
        if (droppedToCell === 1) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 2 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 2, willOccupyCells)
        }

        else if (droppedToCell === 7) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 8 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 8, willOccupyCells)
        }

        else if (droppedToCell === 13) {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells)
        }

        else if (droppedToCell >= 14 && droppedToCell <= 18) {
          this._addRenderedProductToState(product, 14, willOccupyCells)
        }
      }
    }

    else if (willOccupyCells === 8) {
      if (activeInitialBaseplate === '10x3') {
          // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 7 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        // Row 2
        if (droppedToCell >= 11 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell >= 15 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }

        else if (droppedToCell >= 17 && droppedToCell <= 20) {
          this._addRenderedProductToState(product, 17, willOccupyCells)
        }

        // Row 3
        if (droppedToCell >= 21 && droppedToCell <= 22) {
          this._addRenderedProductToState(product, 21, willOccupyCells)
        }

        else if (droppedToCell >= 23 && droppedToCell <= 24) {
          this._addRenderedProductToState(product, 23, willOccupyCells)
        }

        else if (droppedToCell >= 25 && droppedToCell <= 26) {
          this._addRenderedProductToState(product, 25, willOccupyCells)
        }

        else if (droppedToCell >= 27 && droppedToCell <= 30) {
          this._addRenderedProductToState(product, 27, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if ((droppedToCell >= 1 && droppedToCell <= 2) || (droppedToCell >= 11 && droppedToCell <= 12)) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if ((droppedToCell >= 3 && droppedToCell <= 4) || (droppedToCell >= 13 && droppedToCell <= 14)) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if ((droppedToCell >= 5 && droppedToCell <= 6) || (droppedToCell >= 15 && droppedToCell <= 16)) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if ((droppedToCell >= 7 && droppedToCell <= 10) || (droppedToCell >= 17 && droppedToCell <= 20)) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 9 && droppedToCell <= 10) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell >= 11 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        // Top Left
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }
        
        // Top Right
        else if (droppedToCell >= 3 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 3, willOccupyCells);
        }

        // Center Left
        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }

        // Center Right
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells);
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 3 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell >= 13 && droppedToCell <= 16) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
  
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (droppedToCell >= 1 && droppedToCell <= 4) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell >= 5 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      else {
        // Top Left
        if (droppedToCell >= 1 && droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }
        
        // Top Right
        else if (droppedToCell >= 3 && droppedToCell <= 6) {
          this._addRenderedProductToState(product, 3, willOccupyCells);
        }

        // Center Left
        else if (droppedToCell >= 7 && droppedToCell <= 8) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }

        // Center Right
        else if (droppedToCell >= 9 && droppedToCell <= 12) {
          this._addRenderedProductToState(product, 9, willOccupyCells);
        }
        // Bottom Left
        else if (droppedToCell >= 13 && droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells);
        }

        // Bottom Right
        else if (droppedToCell >= 15) {
          this._addRenderedProductToState(product, 15, willOccupyCells);
        }
      }
    }

    // Case for dropping bottle pocket
    // Probably for all cells. TODO: test
    else if (willOccupyCells === 2.2) {
      if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if ((droppedToCell >= 1 && droppedToCell <= 2) || (droppedToCell >= 11 && droppedToCell <= 12)) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if ((droppedToCell >= 3 && droppedToCell <= 4) || (droppedToCell >= 13 && droppedToCell <= 14)) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if ((droppedToCell >= 5 && droppedToCell <= 6) || (droppedToCell >= 15 && droppedToCell <= 16)) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if ((droppedToCell >= 7 && droppedToCell <= 8) || (droppedToCell >= 17 && droppedToCell <= 18)) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }

        else if ((droppedToCell >= 9 && droppedToCell <= 10) || (droppedToCell >= 19 && droppedToCell <= 20)) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }

      else {
        // If the dropping cell is even
        if (droppedToCell % 2 === 0) {
          // Drop to that cell - 1 index, and occupy both of them
          this._addRenderedProductToState(product, droppedToCell - 1, willOccupyCells);
        }

        else {
          this._addRenderedProductToState(product, droppedToCell, willOccupyCells);
        }
      }
    }

    else if (willOccupyCells === 12 || willOccupyCells === 18) {
      if (activeInitialBaseplate === '10x3') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }

        else if (droppedToCell <= 22) {
          this._addRenderedProductToState(product, 21, willOccupyCells)
        }

        else if (droppedToCell <= 24) {
          this._addRenderedProductToState(product, 23, willOccupyCells)
        }

        else if (droppedToCell <= 30) {
          this._addRenderedProductToState(product, 25, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 14) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell <= 16) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        // Top Left
        if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }
      }

      // 6x3
      else {
         // Top Left
        if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }

        else if (droppedToCell <= 18) {
          this._addRenderedProductToState(product, 13, willOccupyCells);
        }
      }
    }

    else if (willOccupyCells === 16) {

      if (activeInitialBaseplate === '10x3') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }


        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell <= 22) {
          this._addRenderedProductToState(product, 21, willOccupyCells)
        }


        else if (droppedToCell <= 30) {
          this._addRenderedProductToState(product, 23, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
         if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 16) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }
      }


      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }
      }
    }

    else if (willOccupyCells === 6) {
      if (activeInitialBaseplate === '10x3') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }

        else if (droppedToCell <= 22) {
          this._addRenderedProductToState(product, 21, willOccupyCells)
        }

        else if (droppedToCell <= 24) {
          this._addRenderedProductToState(product, 23, willOccupyCells)
        }

        else if (droppedToCell <= 30) {
          this._addRenderedProductToState(product, 25, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }

        else if (droppedToCell <= 14) {
          this._addRenderedProductToState(product, 13, willOccupyCells)
        }

        else if (droppedToCell <= 20) {
          this._addRenderedProductToState(product, 15, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 8) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 10) {
          this._addRenderedProductToState(product, 9, willOccupyCells)
        }

        else if (droppedToCell <= 16) {
          this._addRenderedProductToState(product, 11, willOccupyCells)
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        // Top Left
        if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (droppedToCell <= 2) {
          this._addRenderedProductToState(product, 1, willOccupyCells)
        }

        else if (droppedToCell <= 4) {
          this._addRenderedProductToState(product, 3, willOccupyCells)
        }

        else if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 5, willOccupyCells)
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells)
        }
      }

      // 6x3
      else {
         // Top Left
        if (droppedToCell <= 6) {
          this._addRenderedProductToState(product, 1, willOccupyCells);
        }

        else if (droppedToCell <= 12) {
          this._addRenderedProductToState(product, 7, willOccupyCells);
        }

        else if (droppedToCell <= 18) {
          this._addRenderedProductToState(product, 13, willOccupyCells);
        }
      }
    }
  }

  _addRenderedProductToState = (product, droppedToCell, willOccupyCells) => {
    const {variants, handle, id, title, image, price, variantId} = product.productDetails.productDetails;
    const {activePocketSmall, activePocketMedium, activePocketBig, activePocketBottle, activeNylonLoop, activeAluLoop, activeAluHook, activeAluDoubleHook, activePocketXL} = this.state;

    // Update cell availability by calling _this.updateCellAvailability();
    this._updateCellAvailability(droppedToCell, droppedToCell + willOccupyCells)
 

    this.setState(prevState => {
      // Add product to array which will ba rendered on
      // a baseplate
     return {
      addedProducts: [...this.state.addedProducts, {
        title: title,
        imgSrc: image, 
        price: price,
        startCell: droppedToCell,
        endCell: willOccupyCells === 2.2 ? droppedToCell + 6 : droppedToCell + willOccupyCells,
        type: handle,
        variantTitle: title,
        variantId: variantId,
        id: id
      }],
      
      // Add products to cart
      cartProducts: [...this.state.cartProducts, {
        variantId: id,
        quantity: 1
      }],
      cartTotalPrice: prevState.cartTotalPrice += parseFloat(price),
      isDragging: false,
     }
    })
    console.log(this.state.addedProducts)
  }

  // Go trough the cells and make unavailable those
  // which are now occupied
  _updateCellAvailability = (startCell, endCell) => {
    const {activeInitialBaseplate, cells_4x2, cells_10x3, cells} = this.state;

    // IMPORTANT TODO this.state.cells is being updated only for our default baseplate.
    // use (this.state.cells2 etc... for others
    
    // If we drop anything on the baseplate, it means that a user made some
    // modifications. Warn him the progress will be lost.
    window.addEventListener('beforeunload', this._handleLeavePage);

    // L
    if (endCell - startCell === 8) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }

        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
      
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
    
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
    
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 17) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
    
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }

        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 27) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
      }
      
      else if (activeInitialBaseplate === '10x2_KOMPANJA') {

        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(state.cells_8x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},

                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},

              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},

              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_6x2 : update(state.cells_6x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(state.cells_12x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},

              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x2 : update(state.cells_4x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      // If our default our default baseplate
      else {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells : update(state.cells, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells : update(this.state.cells, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells : update(this.state.cells, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells : update(this.state.cells, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
      }
    }

    // XL
    else if (endCell - startCell === 12) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
  
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
      
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
    
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
    
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }

        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
      }
      
      else if (activeInitialBaseplate === '10x2_KOMPANJA') {

        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(state.cells_8x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},

                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},

              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_6x2 : update(state.cells_6x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(state.cells_12x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      // If our default our default baseplate
      else {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells : update(state.cells, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  

        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
      }
    }

    else if (endCell - startCell === 18) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},

                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},

              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},

              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
  
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
      
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
    
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
    
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }

        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
      }
      
      else if (activeInitialBaseplate === '10x2_KOMPANJA') {

        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(state.cells_8x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},

                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},

              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_6x2 : update(state.cells_6x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(state.cells_12x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      // If our default our default baseplate
      else {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells : update(state.cells, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
      
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},

                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
                16: {available: {$set: false }},
                17: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
  

        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
            })
          })
        }
      }
    }

    // XXL
    else if (endCell - startCell === 16) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
                16: {available: {$set: false }},
                17: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
    
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
                16: {available: {$set: false }},
                17: {available: {$set: false }},
      
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
                26: {available: {$set: false }},
                27: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
    
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: false }},
                21: {available: {$set: false }},
                22: {available: {$set: false }},
                23: {available: {$set: false }},
                24: {available: {$set: false }},
                25: {available: {$set: false }},
                26: {available: {$set: false }},
                27: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: false }},
              23: {available: {$set: false }},
              24: {available: {$set: false }},
              25: {available: {$set: false }},
              26: {available: {$set: false }},
              27: {available: {$set: false }},
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
      }
      
      else if (activeInitialBaseplate === '10x2_KOMPANJA') {

        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
      
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
                16: {available: {$set: false }},
                17: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              12: {available: {$set: false }},
              13: {available: {$set: false }},
              14: {available: {$set: false }},
              15: {available: {$set: false }},
              16: {available: {$set: false }},
              17: {available: {$set: false }},
              18: {available: {$set: false }},
              19: {available: {$set: false }},
            })
          })
        }
      } 

      else if (activeInitialBaseplate === '8x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(state.cells_8x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},

                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_8x2 : update(state.cells_8x2, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(state.cells_12x1, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
              6: {available: {$set: false }},
              7: {available: {$set: false }},
              8: {available: {$set: false }},
              9: {available: {$set: false }},
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }
    }

    //B
    else if ((endCell - startCell >= 2.1) && (endCell - startCell <= 2.3)) {
      // For some reason we sometimes get 2.1999999999999993 as the result
      // That's why I use the result range
      
      if (activeInitialBaseplate === '10x3') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              10: {available: {$set: false}},
              11: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
    
              12: {available: {$set: false}},
              13: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              14: {available: {$set: false}},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              16: {available: {$set: false}},
              17: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              18: {available: {$set: false}},
              19: {available: {$set: false }},
            })
          })
        }

        // Second Row
        else if (startCell === 11) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
    
              20: {available: {$set: false}},
              21: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
    
              22: {available: {$set: false}},
              23: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
    
              24: {available: {$set: false}},
              25: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 17) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              16: {available: {$set: false }},
              17: {available: {$set: false }},
    
              26: {available: {$set: false}},
              27: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 19 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              18: {available: {$set: false }},
              19: {available: {$set: false }},
    
              28: {available: {$set: false}},
              29: {available: {$set: false }},
            })
          })
        }

        // Third Row

        else if (startCell === 21) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              20: {available: {$set: false }},
              21: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: false }},
              23: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: false }},
              25: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 27) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              26: {available: {$set: false }},
              27: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 29 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              28: {available: {$set: false }},
              29: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              10: {available: {$set: false}},
              11: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
    
              12: {available: {$set: false}},
              13: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              14: {available: {$set: false}},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              16: {available: {$set: false}},
              17: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9 ) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              18: {available: {$set: false}},
              19: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},

              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},

              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},

              12: {available: {$set: false }},
              13: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},

              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              12: {available: {$set: false }},
              13: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 15) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              14: {available: {$set: false }},
              15: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              6: {available: {$set: false}},
              7: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
    
              8: {available: {$set: false}},
              9: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              10: {available: {$set: false}},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          }) 
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          }) 
        }
  
        else if (startCell === 11) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          }) 
        }
      }

      else if (activeInitialBaseplate === '2x2') {
        if (startCell === 1) {
          this.setState({
            cells_2x2 : update(this.state.cells_2x2, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              2: {available: {$set: false}},
              3: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_2x2 : update(this.state.cells_2x2, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '2x3') {
        if (startCell === 1) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              2: {available: {$set: false}},
              3: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},

              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '2x4') {
        if (startCell === 1) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              2: {available: {$set: false}},
              3: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},

              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 3) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 5) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 7) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 13) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                12: {available: {$set: false }},
                13: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 15) {
          this.setState(state => {
            return {
              cells_4x4 : update(state.cells_4x4, {
                14: {available: {$set: false }},
                15: {available: {$set: false }},
              })
            }
          })
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 3) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 5) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                4: {available: {$set: false }},
                5: {available: {$set: false }},
                8: {available: {$set: false }},
                9: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 7) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                6: {available: {$set: false }},
                7: {available: {$set: false }},
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 9) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                8: {available: {$set: false }},
                9: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_4x3 : update(state.cells_4x3, {
                10: {available: {$set: false }},
                11: {available: {$set: false }},
              })
            }
          })
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_4x2 : update(state.cells_4x2, {
                0: {available: {$set: false }},
                1: {available: {$set: false }},
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 3) {
          this.setState(state => {
            return {
              cells_4x2 : update(state.cells_4x2, {
                2: {available: {$set: false }},
                3: {available: {$set: false }},
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 5) {
          this.setState(state => {
            return {
              cells_4x2 : update(state.cells_4x2, {
                4: {available: {$set: false }},
                5: {available: {$set: false }},
              })
            }
          })
        }

        else if (startCell === 7) {
          this.setState(state => {
            return {
              cells_4x2 : update(state.cells_4x2, {
                6: {available: {$set: false }},
                7: {available: {$set: false }},
              })
            }
          })
        }
      }

      // Default baseplate
      else {
        if (startCell === 1) {
          this.setState({
            cells : update(this.state.cells, {
              0: {available: {$set: false }},
              1: {available: {$set: false }},
    
              6: {available: {$set: false}},
              7: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells : update(this.state.cells, {
              2: {available: {$set: false }},
              3: {available: {$set: false }},
    
              8: {available: {$set: false}},
              9: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells : update(this.state.cells, {
              4: {available: {$set: false }},
              5: {available: {$set: false }},
    
              10: {available: {$set: false}},
              11: {available: {$set: false }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: false }},
              7: {available: {$set: false }},
    
              12: {available: {$set: false}},
              13: {available: {$set: false }},
            })
          }) 
        }
  
        else if (startCell === 9) {
          this.setState({
            cells : update(this.state.cells, {
              8: {available: {$set: false }},
              9: {available: {$set: false }},
    
              14: {available: {$set: false}},
              15: {available: {$set: false }},
            })
          }) 
        }
  
        else if (startCell === 11) {
          this.setState({
            cells : update(this.state.cells, {
              10: {available: {$set: false }},
              11: {available: {$set: false }},
    
              16: {available: {$set: false}},
              17: {available: {$set: false }},
            })
          }) 
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: false }},
              13: {available: {$set: false }}
            })
          }) 
        }
  
        else if (startCell === 15) {
          this.setState({
            cells : update(this.state.cells, {
              14: {available: {$set: false }},
              15: {available: {$set: false }}
            })
          }) 
        }
  
        else if (startCell === 17) {
          this.setState({
            cells : update(this.state.cells, {
              16: {available: {$set: false }},
              17: {available: {$set: false }}
            })
          }) 
        }
      }
    }

    else {
      for (let i = startCell; i < endCell; i++) {
        if (activeInitialBaseplate === '10x3') {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '10x2_KOMPANJA') {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '8x1') {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }


        else if (activeInitialBaseplate === '8x2') {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '6x2') {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x2') {
          this.setState({
            cells_2x2 : update(this.state.cells_2x2, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x3') {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x4') {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '12x1') {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x4') {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x3') {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x2') {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }

        else {
          this.setState({
            cells : update(this.state.cells, {
              [i - 1]: {available: {$set: false }},
            })
          })
        }
      }
    }
  };

  // Go though the cells and make available those
  // which are being removed from the baseplate
  _updateCellUnavailability = (startCell, endCell, type) => {
    const {activeInitialBaseplate} = this.state;
    // IMPORTANT TODO this.state.cells is being updated only for our default baseplate.
    // use (this.state.cells2 etc... for others
    if (endCell - startCell === 16) {

      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
                6: {available: {$set: true }},
                7: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
                16: {available: {$set: true }},
                17: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        }
  
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
                16: {available: {$set: true }},
                17: {available: {$set: true }},
      
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
                26: {available: {$set: true }},
                27: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
    
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
  
        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
                26: {available: {$set: true }},
                27: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
                6: {available: {$set: true }},
                7: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
                16: {available: {$set: true }},
                17: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(this.state.cells_8x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
                6: {available: {$set: true }},
                7: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(this.state.cells_8x2, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
                6: {available: {$set: true }},
                7: {available: {$set: true }},

                8: {available: {$set: true }},
                9: {available: {$set: true }},
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(this.state.cells_12x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
                6: {available: {$set: true }},
                7: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }
    }
    // Pocket XL
    else if (endCell - startCell === 12) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        }
  
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
      
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
    
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
    
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        } 
      }
      
      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(this.state.cells_8x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(this.state.cells_8x2, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},

                8: {available: {$set: true }},
                9: {available: {$set: true }},
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(this.state.cells_12x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }


      // 6x3
      else {
        if (startCell === 1) {
          this.setState({
            cells : update(this.state.cells, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
      }
    }

    else if (endCell - startCell === 18) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},

                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},

              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},

              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
  
        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
      
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
    
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
    
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
                24: {available: {$set: true }},
                25: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
                14: {available: {$set: true }},
                15: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        } 
      }
      
      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(this.state.cells_8x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(this.state.cells_8x2, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},

                8: {available: {$set: true }},
                9: {available: {$set: true }},
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(this.state.cells_12x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
                4: {available: {$set: true }},
                5: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }


      // 6x3
      else {
        if (startCell === 1) {
          this.setState({
            cells : update(this.state.cells, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},

              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
      }
    }

    // Pocket big
    else if (endCell - startCell === 8) {
      if (activeInitialBaseplate === '10x3') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        }

        // Row 2

        else if (startCell === 11) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
      
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
    
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
    
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 17) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
    
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }

        // row 3

        else if (startCell === 21) {
          this.setState(state => {
            return {
              cells_10x3 : update(state.cells_10x3, {
                20: {available: {$set: true }},
                21: {available: {$set: true }},
                22: {available: {$set: true }},
                23: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: true }},
              23: {available: {$set: true }},
              24: {available: {$set: true }},
              25: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: true }},
              25: {available: {$set: true }},
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 27) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              26: {available: {$set: true }},
              27: {available: {$set: true }},
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
      
                10: {available: {$set: true }},
                11: {available: {$set: true }},
                12: {available: {$set: true }},
                13: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              16: {available: {$set: true }},
              17: {available: {$set: true }},
              18: {available: {$set: true }},
              19: {available: {$set: true }},
            })
          })
        }
      }
      
      else if (activeInitialBaseplate === '8x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x1 : update(this.state.cells_8x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_8x2 : update(this.state.cells_8x2, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},

                8: {available: {$set: true }},
                9: {available: {$set: true }},
                10: {available: {$set: true }},
                11: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},

              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: true }},
                9: {available: {$set: true }},
                10: {available: {$set: true }},
                11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // Row 1
        if (startCell === 1) {
          this.setState(state => {
            return {
              cells_12x1 : update(this.state.cells_12x1, {
                0: {available: {$set: true }},
                1: {available: {$set: true }},
                2: {available: {$set: true }},
                3: {available: {$set: true }},
              })
            }
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (startCell === 1) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {   
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {   
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},

              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {   
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
        
      }

      else if (activeInitialBaseplate === '4x3') {
        if (startCell === 1) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {   
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {   
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }        
      }

      else if (activeInitialBaseplate === '4x2') {
        if (startCell === 1) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {   
              4: {available: {$set: true }},
              5: {available: {$set: true }},
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }       
      }

      else {
        if (startCell === 1) {
          this.setState({
            cells : update(this.state.cells, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells : update(this.state.cells, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 9) {
          this.setState({
            cells : update(this.state.cells, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
              10: {available: {$set: true }},
              11: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 15) {
          this.setState({
            cells : update(this.state.cells, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          })
        }
      }
    }

    // Pocket bottle
    else if ((endCell - startCell === 6 && type === 'pocket-b')) {
      // Please note that the difference between end and star cell
      // differ in _updateCellUnavailability and _updateCellAvailability
      if (activeInitialBaseplate === '10x3') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
    
              10: {available: {$set: true}},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              12: {available: {$set: true}},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              14: {available: {$set: true}},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              16: {available: {$set: true}},
              17: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              18: {available: {$set: true}},
              19: {available: {$set: true }},
            })
          })
        }

        // Second Row
        else if (startCell === 11) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
    
              20: {available: {$set: true}},
              21: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
    
              22: {available: {$set: true}},
              23: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 15) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
    
              24: {available: {$set: true}},
              25: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 17) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              16: {available: {$set: true }},
              17: {available: {$set: true }},
    
              26: {available: {$set: true}},
              27: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 19 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              18: {available: {$set: true }},
              19: {available: {$set: true }},
    
              28: {available: {$set: true}},
              29: {available: {$set: true }},
            })
          })
        }

        // Third Row
        else if (startCell === 21) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              20: {available: {$set: true }},
              21: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 23) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              22: {available: {$set: true }},
              23: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 25) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              24: {available: {$set: true }},
              25: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 27) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              26: {available: {$set: true }},
              27: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 29 ) {
          this.setState({
            cells_10x3 : update(this.state.cells_10x3, {
              28: {available: {$set: true }},
              29: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
    
              10: {available: {$set: true}},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              12: {available: {$set: true}},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              14: {available: {$set: true}},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              16: {available: {$set: true}},
              17: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9 ) {
          this.setState({
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              18: {available: {$set: true}},
              19: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x1') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }}
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_8x1 : update(this.state.cells_8x1, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '8x2') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},

              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},

              10: {available: {$set: true }},
              11: {available: {$set: true }}
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},

              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},

              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        // Second Row
        if (startCell === 9) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              10: {available: {$set: true }},
              11: {available: {$set: true }}
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 15) {
          this.setState({
            cells_8x2 : update(this.state.cells_8x2, {
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '6x2') {
        if (startCell === 1) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              8: {available: {$set: true}},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          }) 
        }
  
        else if (startCell === 9) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          }) 
        }
  
        else if (startCell === 11) {
          this.setState({
            cells_6x2 : update(this.state.cells_6x2, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          }) 
        }
      }

      else if (activeInitialBaseplate === '2x2') {
        if (startCell === 1) {
          this.setState({
            cells_2x2 : update(this.state.cells_2x2, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              2: {available: {$set: true }},
              3: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells_2x2 : update(this.state.cells_2x2, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '2x3') {
        if (startCell === 1) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              2: {available: {$set: true }},
              3: {available: {$set: true }},
            })
          })
        }

        if (startCell === 3) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              2: {available: {$set: true}},
              3: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_2x3 : update(this.state.cells_2x3, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }
      }
    
      else if (activeInitialBaseplate === '2x4') {
        if (startCell === 1) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              2: {available: {$set: true }},
              3: {available: {$set: true }},
            })
          })
        }

        if (startCell === 3) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              2: {available: {$set: true}},
              3: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},

              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_2x4 : update(this.state.cells_2x4, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '12x1') {
        // First Row
        if (startCell === 1) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              0: {available: {$set: true }},
              1: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              2: {available: {$set: true }},
              3: {available: {$set: true }}
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_12x1 : update(this.state.cells_12x1, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x4') {
        if (startCell === 1) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              2: {available: {$set: true}},
              3: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              4: {available: {$set: true}},
              5: {available: {$set: true }},
    
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              6: {available: {$set: true}},
              7: {available: {$set: true }},
    
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              8: {available: {$set: true}},
              9: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              10: {available: {$set: true}},
              11: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 13) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              12: {available: {$set: true}},
              13: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 15) {
          this.setState({
            cells_4x4 : update(this.state.cells_4x4, {
              14: {available: {$set: true}},
              15: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x3') {
        if (startCell === 1) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              2: {available: {$set: true}},
              3: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              4: {available: {$set: true}},
              5: {available: {$set: true }},
    
              8: {available: {$set: true }},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              6: {available: {$set: true}},
              7: {available: {$set: true }},
    
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 9) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              8: {available: {$set: true}},
              9: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 11) {
          this.setState({
            cells_4x3 : update(this.state.cells_4x3, {
              10: {available: {$set: true}},
              11: {available: {$set: true }},
            })
          })
        }
      }

      else if (activeInitialBaseplate === '4x2') {
        if (startCell === 1) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              4: {available: {$set: true }},
              5: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 3) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              2: {available: {$set: true}},
              3: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }

        else if (startCell === 5) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              4: {available: {$set: true}},
              5: {available: {$set: true }}
            })
          })
        }

        else if (startCell === 7) {
          this.setState({
            cells_4x2 : update(this.state.cells_4x2, {
              6: {available: {$set: true}},
              7: {available: {$set: true }}
            })
          })
        }
      }

      // Default old baseplate
      else {
        if (startCell === 1) {
          this.setState({
            cells : update(this.state.cells, {
              0: {available: {$set: true}},
              1: {available: {$set: true }},
    
              6: {available: {$set: true }},
              7: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 3) {
          this.setState({
            cells : update(this.state.cells, {
              2: {available: {$set: true }},
              3: {available: {$set: true }},
    
              8: {available: {$set: true}},
              9: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 5) {
          this.setState({
            cells : update(this.state.cells, {
              4: {available: {$set: true }},
              5: {available: {$set: true }},
    
              10: {available: {$set: true }},
              11: {available: {$set: true }},
            })
          })
        }
  
        else if (startCell === 7) {
          this.setState({
            cells : update(this.state.cells, {
              6: {available: {$set: true }},
              7: {available: {$set: true }},
    
              12: {available: {$set: true }},
              13: {available: {$set: true }},
            })
          }) 
        }
  
        else if (startCell === 9) {
          this.setState({
            cells : update(this.state.cells, {
              8: {available: {$set: true }},
              9: {available: {$set: true }},
    
              14: {available: {$set: true }},
              15: {available: {$set: true }},
            })
          }) 
        }
  
        else if (startCell === 11) {
          this.setState({
            cells : update(this.state.cells, {
              10: {available: {$set: true }},
              11: {available: {$set: true }},
    
              16: {available: {$set: true }},
              17: {available: {$set: true }},
            })
          }) 
        }
  
        else if (startCell === 13) {
          this.setState({
            cells : update(this.state.cells, {
              12: {available: {$set: true }},
              13: {available: {$set: true }}
            })
          }) 
        }
  
        else if (startCell === 15) {
          this.setState({
            cells : update(this.state.cells, {
              14: {available: {$set: true }},
              15: {available: {$set: true }}
            })
          }) 
        }
  
        else if (startCell === 17) {
          this.setState({
            cells : update(this.state.cells, {
              16: {available: {$set: true }},
              17: {available: {$set: true }}
            })
          }) 
        }
      }
    }

    else {
      for (let i = startCell; i < endCell; i++) {
        if (activeInitialBaseplate === '10x3') {
          this.setState({
            cells_10x3: update(this.state.cells_10x3, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '10x2_KOMPANJA') {
          this.setState({
            cells_10x2_KOMPANJA: update(this.state.cells_10x2_KOMPANJA, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '8x1') {
          this.setState({
            cells_8x1: update(this.state.cells_8x1, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '8x2') {
          this.setState({
            cells_8x2: update(this.state.cells_8x2, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '6x2') {
          this.setState({
            cells_6x2: update(this.state.cells_6x2, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x2') {
          this.setState({
            cells_2x2: update(this.state.cells_2x2, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x3') {
          this.setState({
            cells_2x3: update(this.state.cells_2x3, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '2x4') {
          this.setState({
            cells_2x4: update(this.state.cells_2x4, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '12x1') {
          this.setState({
            cells_12x1: update(this.state.cells_12x1, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x4') {
          this.setState({
            cells_4x4: update(this.state.cells_4x4, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x3') {
          this.setState({
            cells_4x3: update(this.state.cells_4x3, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else if (activeInitialBaseplate === '4x2') {
          this.setState({
            cells_4x2: update(this.state.cells_4x2, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }

        else {
          this.setState({
            cells : update(this.state.cells, {
              [i - 1]: {available: {$set: true }},
            })
          })
        }
      }
    } 
  }

  _disableAllCells() {
    const {activeInitialBaseplate} = this.state;
    if (activeInitialBaseplate === '10x3') {
      this.setState({
        cells_10x3 : update(this.state.cells_10x3, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
          12: {available: {$set: false}},
          13: {available: {$set: false}},
          14: {available: {$set: false}},
          15: {available: {$set: false}},
          16: {available: {$set: false}},
          17: {available: {$set: false}},
          18: {available: {$set: false}},
          19: {available: {$set: false}},
          20: {available: {$set: false}},
          21: {available: {$set: false}},
          22: {available: {$set: false}},
          23: {available: {$set: false}},
          24: {available: {$set: false}},
          25: {available: {$set: false}},
          26: {available: {$set: false}},
          27: {available: {$set: false}},
          28: {available: {$set: false}},
          29: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '10x2_KOMPANJA') {
      this.setState({
        cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
          12: {available: {$set: false}},
          13: {available: {$set: false}},
          14: {available: {$set: false}},
          15: {available: {$set: false}},
          16: {available: {$set: false}},
          17: {available: {$set: false}},
          18: {available: {$set: false}},
          19: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '8x1') {
      this.setState({
        cells_8x1 : update(this.state.cells_8x1, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '8x2') {
      this.setState({
        cells_8x2 : update(this.state.cells_8x2, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},

          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
          12: {available: {$set: false}},
          13: {available: {$set: false}},
          14: {available: {$set: false}},
          15: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '6x2') {
      this.setState({
        cells_6x2 : update(this.state.cells_6x2, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '2x2') {
      this.setState({
        cells_2x2 : update(this.state.cells_2x2, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '2x3') {
      this.setState({
        cells_2x3 : update(this.state.cells_2x3, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '2x4') {
      this.setState({
        cells_2x4 : update(this.state.cells_2x4, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '12x1') {
      this.setState({
        cells_12x1 : update(this.state.cells_12x1, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '4x4') {
      this.setState({
        cells_4x4 : update(this.state.cells_4x4, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
          12: {available: {$set: false}},
          13: {available: {$set: false}},
          14: {available: {$set: false}},
          15: {available: {$set: false}},
        })
      })
    }

    else if (activeInitialBaseplate === '4x3') {
      this.setState({
        cells_4x3 : update(this.state.cells_4x3, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
          8: {available: {$set: false}},
          9: {available: {$set: false}},
          10: {available: {$set: false}},
          11: {available: {$set: false}},
        })
      })
    }
    
    else if (activeInitialBaseplate === '4x2') {
      this.setState({
        cells_4x2 : update(this.state.cells_4x2, {
          0: {available: {$set: false}},
          1: {available: {$set: false}},
          2: {available: {$set: false}},
          3: {available: {$set: false}},
          4: {available: {$set: false}},
          5: {available: {$set: false}},
          6: {available: {$set: false}},
          7: {available: {$set: false}},
        })
      })
    }
    else {
      this.setState({
        cells : update(this.state.cells, {
          0: {available: {$set: false }},
          1: {available: {$set: false }},
          2: {available: {$set: false }},
          3: {available: {$set: false }},
          4: {available: {$set: false }},
          5: {available: {$set: false }},
          6: {available: {$set: false }},
          7: {available: {$set: false }},
          8: {available: {$set: false }},
          9: {available: {$set: false }},
          10: {available: {$set: false }},
          11: {available: {$set: false }},
          12: {available: {$set: false }},
          13: {available: {$set: false }},
          14: {available: {$set: false }},
          15: {available: {$set: false }},
          16: {available: {$set: false }},
          17: {available: {$set: false }},
        })
      })
    }
  }

  _resetDrawingCells = () => {
    // TODO: Refactor so it uses loops
    const { activeInitialBaseplate } = this.state;

    if (activeInitialBaseplate === '10x3') {
      this.setState({
        cells_10x3 : update(this.state.cells_10x3, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
          12: {drawPreview: {$set: false}},
          13: {drawPreview: {$set: false}},
          14: {drawPreview: {$set: false}},
          15: {drawPreview: {$set: false}},
          16: {drawPreview: {$set: false}},
          17: {drawPreview: {$set: false}},
          18: {drawPreview: {$set: false}},
          19: {drawPreview: {$set: false}},
          20: {drawPreview: {$set: false}},
          21: {drawPreview: {$set: false}},
          22: {drawPreview: {$set: false}},
          23: {drawPreview: {$set: false}},
          24: {drawPreview: {$set: false}},
          25: {drawPreview: {$set: false}},
          26: {drawPreview: {$set: false}},
          27: {drawPreview: {$set: false}},
          28: {drawPreview: {$set: false}},
          29: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '10x2_KOMPANJA') {
      this.setState({
        cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
          12: {drawPreview: {$set: false}},
          13: {drawPreview: {$set: false}},
          14: {drawPreview: {$set: false}},
          15: {drawPreview: {$set: false}},
          16: {drawPreview: {$set: false}},
          17: {drawPreview: {$set: false}},
          18: {drawPreview: {$set: false}},
          19: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '8x1') {
      this.setState({
        cells_8x1 : update(this.state.cells_8x1, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '8x2') {
      this.setState({
        cells_8x2 : update(this.state.cells_8x2, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},

          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
          12: {drawPreview: {$set: false}},
          13: {drawPreview: {$set: false}},
          14: {drawPreview: {$set: false}},
          15: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '6x2') {
      this.setState({
        cells_6x2 : update(this.state.cells_6x2, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '2x2') {
      this.setState({
        cells_2x2 : update(this.state.cells_2x2, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '2x3') {
      this.setState({
        cells_2x3 : update(this.state.cells_2x3, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '2x4') {
      this.setState({
        cells_2x4 : update(this.state.cells_2x4, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '12x1') {
      this.setState({
        cells_12x1 : update(this.state.cells_12x1, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '4x4') {
      this.setState({
        cells_4x4 : update(this.state.cells_4x4, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
          12: {drawPreview: {$set: false}},
          13: {drawPreview: {$set: false}},
          14: {drawPreview: {$set: false}},
          15: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else if (activeInitialBaseplate === '4x3') {
      this.setState({
        cells_4x3 : update(this.state.cells_4x3, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }
    
    else if (activeInitialBaseplate === '4x2') {
      this.setState({
        cells_4x2 : update(this.state.cells_4x2, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }

    else {
      this.setState({
        cells : update(this.state.cells, {
          0: {drawPreview: {$set: false}},
          1: {drawPreview: {$set: false}},
          2: {drawPreview: {$set: false}},
          3: {drawPreview: {$set: false}},
          4: {drawPreview: {$set: false}},
          5: {drawPreview: {$set: false}},
          6: {drawPreview: {$set: false}},
          7: {drawPreview: {$set: false}},
          8: {drawPreview: {$set: false}},
          9: {drawPreview: {$set: false}},
          10: {drawPreview: {$set: false}},
          11: {drawPreview: {$set: false}},
          12: {drawPreview: {$set: false}},
          13: {drawPreview: {$set: false}},
          14: {drawPreview: {$set: false}},
          15: {drawPreview: {$set: false}},
          16: {drawPreview: {$set: false}},
          17: {drawPreview: {$set: false}},
        }),
        willOccupyCells: 0,
        draggingProduct: {}
      })
    }
  };

	_calculatePreviewCells = (hoverCell) => {
    this.setState({
      hoverCell
    })
    const { willOccupyCells, activeInitialBaseplate } = this.state;

    // Small Pocket
    if (willOccupyCells === 2) {
      this.setState(state => {
        if (activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 9 */ 8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            /* 17 */ 16: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
            /* 18 */ 17: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
            /* 19 */ 18: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20}},
            /* 20 */ 19: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20}},

            /* 21 */ 20: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22}},
            /* 22 */ 21: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22}},
            /* 23 */ 22: {drawPreview: {$set: hoverCell === 23 || hoverCell === 24}},
            /* 24 */ 23: {drawPreview: {$set: hoverCell === 23 || hoverCell === 24}},
            /* 25 */ 24: {drawPreview: {$set: hoverCell === 25 || hoverCell === 26}},
            /* 26 */ 25: {drawPreview: {$set: hoverCell === 25 || hoverCell === 26}},
            /* 27 */ 26: {drawPreview: {$set: hoverCell === 27 || hoverCell === 28}},
            /* 28 */ 27: {drawPreview: {$set: hoverCell === 27 || hoverCell === 28}},
            /* 29 */ 28: {drawPreview: {$set: hoverCell === 29 || hoverCell === 30}},
            /* 30 */ 29: {drawPreview: {$set: hoverCell === 29 || hoverCell === 30}},
            })
          }
        }

        else if (activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 9 */ 8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            /* 17 */ 16: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
            /* 18 */ 17: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
            /* 19 */ 18: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20}},
            /* 20 */ 19: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20}},
            })
          }
        }

        else if (activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            })
          }
        }

        else if (activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},

            /* 9 */ 8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            })
          }
        }

        else if (activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            })
          }
        }

        else if (activeInitialBaseplate === '2x2') {
          return {
            cells_2x2 : update(state.cells_2x2, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            })
          }
        }

        else if (activeInitialBaseplate === '2x3') {
          return {
            cells_2x3 : update(state.cells_2x3, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            })
          }
        }

        else if (activeInitialBaseplate === '2x4') {
          return {
            cells_2x4 : update(state.cells_2x4, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}}
            })
          }
        }

        else if (activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},

            /* 9 */ 8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            })
          }
        }

        else if (activeInitialBaseplate === '4x4') {
          return {
            cells_4x4 : update(state.cells_4x4, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},

              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},

              8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              
              12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              14: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
              15: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
            })
          } 
        }

        else if (activeInitialBaseplate === '4x3') {
          return {
            cells_4x3 : update(state.cells_4x3, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},

              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},

              8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            })
          } 
        }

        else if (activeInitialBaseplate === '4x2') {
          return {
            cells_4x2 : update(state.cells_4x2, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},

              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}}
            })
          } 
        }

        // Refers to our original baseplate
        else {
          return {
            cells : update(state.cells, {
              0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
              4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
              6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              14: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
              15: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16}},
              16: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
              17: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18}},
            })
          }
        } 
      })
    }
    // Bottle pocket
    else if (willOccupyCells === 2.2) {
      this.setState(state => {
        if (activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(this.state.cells_10x3, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},
            /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 }},

            /* 11 */ 10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 17 */ 16: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 18 */ 17: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 19 */ 18: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},
            /* 20 */ 19: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},

            /* 21 */ 20: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 21 || hoverCell === 22 }},
            /* 22 */ 21: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 21 || hoverCell === 22 }},
            /* 23 */ 22: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 23 || hoverCell === 24 }},
            /* 24 */ 23: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 23 || hoverCell === 24 }},
            /* 25 */ 24: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 25 || hoverCell === 26 }},
            /* 26 */ 25: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 25 || hoverCell === 26 }},
            /* 27 */ 26: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 27 || hoverCell === 28 }},
            /* 28 */ 27: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 27 || hoverCell === 28 }},
            /* 29 */ 28: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20 || hoverCell === 29 || hoverCell === 30 }},
            /* 30 */ 29: {drawPreview: {$set: hoverCell === 19 || hoverCell === 20 || hoverCell === 29 || hoverCell === 30 }},
            })
          }
        }

        else if (activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},

            /* 11 */ 10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 13 || hoverCell === 14 }},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 15 || hoverCell === 16 }},
            /* 17 */ 16: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 18 */ 17: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 17 || hoverCell === 18 }},
            /* 19 */ 18: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},
            /* 20 */ 19: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 19 || hoverCell === 20 }},
            })
          }
        }

        else if (activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(this.state.cells_8x1, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},
            })
          }
        }

        else if (activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(this.state.cells_8x2, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 }},

            /* 9 */  8: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10 }},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 11 || hoverCell === 12 }},
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 13 || hoverCell === 14 }},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 13 || hoverCell === 14 }},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 15 || hoverCell === 16 }},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 15 || hoverCell === 16 }},
            })
          }
        }

        else if (activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(this.state.cells_6x2, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
    
            /* 7 */  6: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
            /* 9 */  8: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 }},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 11 || hoverCell === 12 }},
            })
          }
        }

        else if (activeInitialBaseplate === '2x2') {
          return {
            cells_2x2 : update(this.state.cells_2x2, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            })
          }
        }

        else if (activeInitialBaseplate === '2x3') {
          return {
            cells_2x3 : update(this.state.cells_2x3, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
            })
          }
        }

        else if (activeInitialBaseplate === '2x4') {
          return {
            cells_2x4 : update(this.state.cells_2x4, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
            })
          }
        }

        else if (activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
            /* 1 */ 0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 2 */ 1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
            /* 3 */ 2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 4 */ 3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4}},
            /* 5 */ 4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 6 */ 5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6}},
            /* 7 */ 6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
            /* 8 */ 7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},

            /* 9 */ 8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
            })
          }
        }

        else if (activeInitialBaseplate === '4x4') {
          return {
            cells_4x4 : update(this.state.cells_4x4, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},

            /* 5 */  4: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},

            /* 9 */  8: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 9 || hoverCell === 10 }},

            /* 11 */ 10: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 11 || hoverCell === 12 }},
    
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 13 || hoverCell === 14 }},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 13 || hoverCell === 14 }},

            /* 15 */ 14: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 15 || hoverCell === 16 }},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 15 || hoverCell === 16 }},
            })
          }
        }

        else if (activeInitialBaseplate === '4x3') {
          return {
            cells_4x3 : update(this.state.cells_4x3, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},

            /* 5 */  4: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},

            /* 9 */  8: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 9 || hoverCell === 10 }},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 11 || hoverCell === 12 }},
            })
          }
        }

        else if (activeInitialBaseplate === '4x2') {
          return {
            cells_4x2 : update(this.state.cells_4x2, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},

            /* 5 */  4: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 5 || hoverCell === 6 }},
            /* 7 */  6: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 7 || hoverCell === 8 }},
            })
          }
        }

        else {
          return {
            cells : update(this.state.cells, {
            /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
            /* 3 */  2: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 4 */  3: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 }},
            /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
            /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 }},
    
            /* 7 */  6: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
            /* 8 */  7: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
            /* 9 */  8: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 }},
            /* 10 */ 9: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 }},
            /* 11 */ 10: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 11 || hoverCell === 12 }},
            /* 12 */ 11: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 11 || hoverCell === 12 }},
    
            /* 13 */ 12: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 13 || hoverCell === 14 }},
            /* 14 */ 13: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 13 || hoverCell === 14 }},
            /* 15 */ 14: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 15 || hoverCell === 16 }},
            /* 16 */ 15: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 15 || hoverCell === 16 }},
            /* 17 */ 16: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 17 || hoverCell === 18 }},
            /* 18 */ 17: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 17 || hoverCell === 18 }},
            })
          }
        }
      })
    }
    // Medium Pocket
    else if (willOccupyCells === 4) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},

              /* 13 */  12: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14}},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14}},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 17 */  16: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 18 */  17: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 19 */  18: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 20 */  19: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 21 */  20: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22}},
              /* 22 */  21: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22}},

              /* 23 */  22: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22 || hoverCell === 23 || hoverCell === 24}},
              /* 24 */  23: {drawPreview: {$set: hoverCell === 21 || hoverCell === 22 || hoverCell === 23 || hoverCell === 24}},
              /* 25 */  24: {drawPreview: {$set: hoverCell === 23 || hoverCell === 24 || hoverCell === 25 || hoverCell === 26}},
              /* 26 */  25: {drawPreview: {$set: hoverCell === 23 || hoverCell === 24 || hoverCell === 25 || hoverCell === 26}},
              /* 27 */  26: {drawPreview: {$set: hoverCell === 25 || hoverCell === 26 || hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30}},
              /* 28 */  27: {drawPreview: {$set: hoverCell === 25 || hoverCell === 26 || hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30}},
              /* 29 */  28: {drawPreview: {$set: hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30}},
              /* 30 */  29: {drawPreview: {$set: hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30}},          
            })
          } 
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10}},
              
              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12}},
              /* 13 */  12: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14}},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14}},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 17 */  16: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 18 */  17: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 19 */  18: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
              /* 20 */  19: {drawPreview: {$set: hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},         
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
             
              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},

              /* 13 */  12: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16}},

            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */ 9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '4x4') {
          return {
            cells_4x4 : update(state.cells_4x4, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},

              /* 13 */  12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x3') {
          return {
            cells_4x3 : update(state.cells_4x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x2') {
          return {
            cells_4x2 : update(state.cells_4x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
            })
          }
        }
        
        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8}},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12}},
              /* 13 */  12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14}},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18}},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18}},
              /* 17 */  16: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18}},
              /* 18 */  17: {drawPreview: {$set: hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18}}
            })
          }
        }
      })
    }
    
    else if (willOccupyCells === 5) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 3}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 5}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 4 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 6 && hoverCell <= 10}},


              /* 11 */  10: {drawPreview: {$set: hoverCell === 11}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 12}},
              /* 13 */  12: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 13}},
              /* 14 */  13: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 14}},
              /* 15 */  14: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 15}},
              /* 16 */  15: {drawPreview: {$set: hoverCell >= 12 && hoverCell <= 20}},
              /* 17 */  16: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 20}},
              /* 18 */  17: {drawPreview: {$set: hoverCell >= 14 && hoverCell <= 20}},
              /* 19 */  18: {drawPreview: {$set: hoverCell >= 15 && hoverCell <= 20}},
              /* 20 */  19: {drawPreview: {$set: hoverCell >= 16 && hoverCell <= 20}},
              
              /* 21 */  20: {drawPreview: {$set: hoverCell === 21}},
              /* 22 */  21: {drawPreview: {$set: hoverCell >= 21 && hoverCell <= 22}},
              /* 23 */  22: {drawPreview: {$set: hoverCell >= 21 && hoverCell <= 23}},
              /* 24 */  23: {drawPreview: {$set: hoverCell >= 21 && hoverCell <= 24}},
              /* 25 */  24: {drawPreview: {$set: hoverCell >= 21 && hoverCell <= 25}},
              /* 26 */  25: {drawPreview: {$set: hoverCell >= 22 && hoverCell <= 30}},
              /* 27 */  26: {drawPreview: {$set: hoverCell >= 23 && hoverCell <= 30}},
              /* 28 */  27: {drawPreview: {$set: hoverCell >= 24 && hoverCell <= 30}},
              /* 29 */  28: {drawPreview: {$set: hoverCell >= 25 && hoverCell <= 30}},
              /* 30 */  29: {drawPreview: {$set: hoverCell >= 26 && hoverCell <= 30}},        
            })
          } 
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 3}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 5}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 4 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 6 && hoverCell <= 10}},


              /* 11 */  10: {drawPreview: {$set: hoverCell === 11}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 12}},
              /* 13 */  12: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 13}},
              /* 14 */  13: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 14}},
              /* 15 */  14: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 15}},
              /* 16 */  15: {drawPreview: {$set: hoverCell >= 12 && hoverCell <= 20}},
              /* 17 */  16: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 20}},
              /* 18 */  17: {drawPreview: {$set: hoverCell >= 14 && hoverCell <= 20}},
              /* 19 */  18: {drawPreview: {$set: hoverCell >= 15 && hoverCell <= 20}},
              /* 20 */  19: {drawPreview: {$set: hoverCell >= 16 && hoverCell <= 20}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 3}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 4 && hoverCell <= 8}},     
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 3}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 4 && hoverCell <= 8}},     

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 10}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 11}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
              /* 13 */  12: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
              /* 14 */  13: {drawPreview: {$set: hoverCell >= 10 && hoverCell <= 16}},
              /* 15 */  14: {drawPreview: {$set: hoverCell >= 11 && hoverCell <= 16}},
              /* 16 */  15: {drawPreview: {$set: hoverCell >= 12 && hoverCell <= 16}},     

            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 6}},

              /* 7 */  6: {drawPreview: {$set: hoverCell === 7}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 8 && hoverCell <= 12}},
              
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 3}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 5}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 7}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 4 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 6 && hoverCell <= 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 8 && hoverCell <= 12}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '4x4') {
          return {
            cells_4x4 : update(state.cells_4x4, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},

              /* 13 */  12: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 14 */  13: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 15 */  14: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
              /* 16 */  15: {drawPreview: {$set: hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16 }},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x3') {
          return {
            cells_4x3 : update(state.cells_4x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x2') {
          return {
            cells_4x2 : update(state.cells_4x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
            })
          }
        }
        
        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 2 && hoverCell <= 6}},

              /* 7 */  6: {drawPreview: {$set: hoverCell === 7}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 8 && hoverCell <= 12}},

              /* 13 */  12: {drawPreview: {$set: hoverCell === 13}},
              /* 14 */  13: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 18}},
              /* 15 */  14: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 18}},
              /* 16 */  15: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 18}},
              /* 17 */  16: {drawPreview: {$set: hoverCell >= 13 && hoverCell <= 18}},
              /* 18 */  17: {drawPreview: {$set: hoverCell >= 14 && hoverCell <= 18}},
            })
          }
        }
      })
    }

    else if (willOccupyCells === 8) {
      this.setState(state => {

        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10 }},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 10 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 10 }},
              /* 11 */  10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20) }},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20) }},
              /* 21 */  20: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 21 || hoverCell === 22 }},
              /* 22 */  21: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 21 || hoverCell === 22 }},
              /* 23 */  22: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 21 && hoverCell <= 24) }},
              /* 24 */  23: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 21 && hoverCell <= 24) }},
              /* 25 */  24: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 16) || (hoverCell >= 23 && hoverCell <= 26) }},
              /* 26 */  25: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 16) || (hoverCell >= 23 && hoverCell <= 26) }},
              /* 27 */  26: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 25 && hoverCell <= 30) }},
              /* 28 */  27: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 25 && hoverCell <= 30) }},
              /* 29 */  28: {drawPreview: {$set: (hoverCell >= 17 && hoverCell <= 20) || (hoverCell >= 27 && hoverCell <= 30) }},
              /* 30 */  29: {drawPreview: {$set: (hoverCell >= 17 && hoverCell <= 20) || (hoverCell >= 27 && hoverCell <= 30) }}
            })
          }
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20) }},
              /* 10 */ 9: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20) }},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4) || (hoverCell >= 11 && hoverCell <= 14) }},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 13 && hoverCell <= 16) }},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10) || (hoverCell >= 15 && hoverCell <= 20) }},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20)  }},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 10) || (hoverCell >= 17 && hoverCell <= 20)  }},
            })
          }
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},         
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }}, 
              
              /* 9 */  8: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},
              /* 10 */ 9: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},

              /* 11 */ 10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */ 11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              
              /* 13 */ 12: {drawPreview: {$set: (hoverCell >=3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},
              /* 14 */ 13: {drawPreview: {$set: (hoverCell >=3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},
              
              /* 15 */ 14: {drawPreview: {$set: (hoverCell >=5 && hoverCell <= 8) || (hoverCell >= 13 && hoverCell <= 16)}},
              /* 16 */ 15: {drawPreview: {$set: (hoverCell >=5 && hoverCell <= 8) || (hoverCell >= 13 && hoverCell <= 16)}},  
            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
      
              /* 7 */  6: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 10 */ 9: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 11 */ 10: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 9 && hoverCell <= 12) }},
              /* 12 */ 11: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 9 && hoverCell <= 12) }},
  
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
              /* 6 */  5: {drawPreview: {$set: hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 }},
              /* 7 */  6: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 }},
              /* 9 */  8: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 10 */ 9: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              
              /* 11 */  10: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12 }},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '4x4') {
          return {
            cells_4x4 : update(state.cells_4x4, {
              /* 1 */  0: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},

              /* 13 */  12: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
              /* 14 */  13: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
              /* 15 */  14: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
              /* 16 */  15: {drawPreview: {$set: hoverCell >= 9 && hoverCell <= 16}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x3') {
          return {
            cells_4x3 : update(state.cells_4x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},

              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '4x2') {
          return {
            cells_4x2 : update(state.cells_4x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 2 */  1: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},

              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 8}},
            })
          }
        }

        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 }},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6 }},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6 }},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 6 }},
      
              /* 7 */  6: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
              /* 8 */  7: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 7 || hoverCell === 8 }},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 10 */ 9: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 11 */ 10: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 9 && hoverCell <= 12) }},
              /* 12 */ 11: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 6) || (hoverCell >= 9 && hoverCell <= 12) }},
      
              /* 13 */ 12: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 13 || hoverCell ===14 }},
              /* 14 */ 13: {drawPreview: {$set: hoverCell === 7 || hoverCell === 8 || hoverCell === 13 || hoverCell ===14 }},
              /* 15 */ 14: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 18}},
              /* 16 */ 15: {drawPreview: {$set: hoverCell >= 7 && hoverCell <= 18}},
              /* 17 */ 16: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 12) || (hoverCell >= 15 && hoverCell <= 18)}},
              /* 18 */ 17: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 12) || (hoverCell >= 15 && hoverCell <= 18)}},
            })
          }
        }
      })
    }

    else if (willOccupyCells === 12) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},

              /* 21 */  20: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12)}},
              /* 22 */  21: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12)}},
              /* 23 */  22: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) || (hoverCell >= 11 && hoverCell <= 14)}},
              /* 24 */  23: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) || (hoverCell >= 11 && hoverCell <= 14)}},
              /* 25 */  24: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) || (hoverCell >= 11 && hoverCell <= 20)}},
              /* 26 */  25: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) || (hoverCell >= 11 && hoverCell <= 20)}},
              /* 27 */  26: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20)}},
              /* 28 */  27: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20)}},
              /* 29 */  28: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) || (hoverCell >= 15 && hoverCell <= 20)}},
              /* 30 */  29: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) || (hoverCell >= 15 && hoverCell <= 20)}},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},  

              /* 9 */  8: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},  
            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},  
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 7 }},  
            })
          } 
        }
        
        // 6x3
        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell <= 12)}},

              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 7)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 7)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 7)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 7)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 7)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 7)}},
            })
          }
        }
      })
    }

    else if (willOccupyCells === 18) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},

              /* 21 */  20: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2)}},
              /* 22 */  21: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2)}},
              /* 23 */  22: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) || (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 24 */  23: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) || (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 25 */  24: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) || (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 26 */  25: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) || (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 27 */  26: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 28 */  27: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 29 */  28: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) || (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 30 */  29: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) || (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},      
            })
          } 
        }
        
        // Kompanja not awailable ???
        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) || (hoverCell >= 1 && hoverCell <= 4)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) || (hoverCell >= 1 && hoverCell <= 10)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) || (hoverCell >= 5 && hoverCell <= 10)}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},  

              /* 9 */  8: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 9 || hoverCell === 10}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8) || (hoverCell >= 11 && hoverCell <= 16)}},  
            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 12)}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},  
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 7 }},  
            })
          } 
        }
        
        // 6x3
        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell <= 12)}},

              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 1)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 1)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 1)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 1)}},
            })
          }
        }
      })
    }

    else if (willOccupyCells === 16) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 || hoverCell === 1 || hoverCell === 2}},

              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},

              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},


              /* 21 */  20: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12)}},
              /* 22 */  21: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 || hoverCell === 11 || hoverCell === 12)}},
              
              /* 23 */  22: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},
              /* 24 */  23: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},
              /* 25 */  24: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},
              /* 26 */  25: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},
              /* 27 */  26: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},
              /* 28 */  27: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 30)}},

              /* 29 */  28: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20)}},
              /* 30 */  29: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) || (hoverCell >= 13 && hoverCell <= 20)}},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12 }},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 20}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10 || hoverCell >= 13 && hoverCell <= 20 }},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10 || hoverCell >= 13 && hoverCell <= 20 }},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2 || hoverCell === 11 || hoverCell === 12}},

              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 20)}},

              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) || (hoverCell >= 3 && hoverCell <= 10)}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}}, 
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},

              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8) || (hoverCell >= 9 && hoverCell <= 16)}},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},

              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},


              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 12}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 12}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 12}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 12}},
              
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},  

              /* 11 */  10: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},  
            })
          } 
        }
      })
    }

    else if (willOccupyCells === 6) {
      this.setState(state => {
        if (state.activeInitialBaseplate === '10x3') {
          return {
            cells_10x3 : update(state.cells_10x3, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 10}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 10}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 10}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 }},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) }},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) }},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) }},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) }},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) }},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) }},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) }},

              /* 21 */  20: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 )}},
              /* 22 */  21: {drawPreview: {$set: (hoverCell === 21 || hoverCell === 22 )}},
              /* 23 */  22: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) }},
              /* 24 */  23: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 24) }},
              /* 25 */  24: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) }},
              /* 26 */  25: {drawPreview: {$set: (hoverCell >= 21 && hoverCell <= 30) }},
              /* 27 */  26: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) }},
              /* 28 */  27: {drawPreview: {$set: (hoverCell >= 23 && hoverCell <= 30) }},
              /* 29 */  28: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) }},
              /* 30 */  29: {drawPreview: {$set: (hoverCell >= 25 && hoverCell <= 30) }},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '10x2_KOMPANJA') {
          return {
            cells_10x2_KOMPANJA : update(state.cells_10x2_KOMPANJA, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 4)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 10)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 10)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 10)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 10)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 5 && hoverCell <= 10)}},

              /* 11 */  10: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell === 11 || hoverCell === 12 }},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 14) }},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) }},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 20) }},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) }},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13 && hoverCell <= 20) }},
              /* 19 */  18: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) }},
              /* 20 */  19: {drawPreview: {$set: (hoverCell >= 15 && hoverCell <= 20) }},
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x1') {
          return {
            cells_8x1 : update(state.cells_8x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},      
            })
          } 
        }

        else if (state.activeInitialBaseplate === '8x2') {
          return {
            cells_8x2 : update(state.cells_8x2, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 8)}},
              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 3 && hoverCell <= 8)}},  

              /* 9 */  8: {drawPreview: {$set: hoverCell === 9 || hoverCell === 10}},
              /* 10 */  9: {drawPreview: {$set:  hoverCell === 9 || hoverCell === 10}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 16)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 16)}},
              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 16) }},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 9 && hoverCell <= 16)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 16)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 11 && hoverCell <= 16)}},  
            })
          } 
        }

        else if (state.activeInitialBaseplate === '6x2') {
          return {
            cells_6x2 : update(state.cells_6x2, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell >= 1 && hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
            })
          }
        }

        else if (state.activeInitialBaseplate === '12x1') {
          return {
            cells_12x1 : update(state.cells_12x1, {
              /* 1 */  0: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 2 */  1: {drawPreview: {$set: hoverCell === 1 || hoverCell === 2}},
              /* 3 */  2: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 4 */  3: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 4}},
              /* 5 */  4: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 6 */  5: {drawPreview: {$set: hoverCell >= 1 && hoverCell <= 6}},
              /* 7 */  6: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 8 */  7: {drawPreview: {$set: hoverCell >= 3 && hoverCell <= 12}},
              /* 9 */  8: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},
              /* 10 */  9: {drawPreview: {$set: hoverCell >= 5 && hoverCell <= 12}},  
              /* 11 */  10: {drawPreview: {$set: hoverCell >= 7 }},
              /* 12 */  11: {drawPreview: {$set: hoverCell >= 7 }},  
            })
          } 
        }
        
        // 6x3
        else {
          return {
            cells : update(state.cells, {
              /* 1 */  0: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 2 */  1: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 3 */  2: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 4 */  3: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 5 */  4: {drawPreview: {$set: (hoverCell <= 6)}},
              /* 6 */  5: {drawPreview: {$set: (hoverCell <= 6)}},

              /* 7 */  6: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 8 */  7: {drawPreview: {$set: (hoverCell >= 7 &&  hoverCell <= 12)}},
              /* 9 */  8: {drawPreview: {$set: (hoverCell >= 7 &&  hoverCell <= 12)}},
              /* 10 */  9: {drawPreview: {$set: (hoverCell >= 7 &&  hoverCell <= 12)}},
              /* 11 */  10: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},
              /* 12 */  11: {drawPreview: {$set: (hoverCell >= 7 && hoverCell <= 12)}},

              /* 13 */  12: {drawPreview: {$set: (hoverCell >= 13)}},
              /* 14 */  13: {drawPreview: {$set: (hoverCell >= 13)}},
              /* 15 */  14: {drawPreview: {$set: (hoverCell >= 13)}},
              /* 16 */  15: {drawPreview: {$set: (hoverCell >= 13)}},
              /* 17 */  16: {drawPreview: {$set: (hoverCell >= 13)}},
              /* 18 */  17: {drawPreview: {$set: (hoverCell >= 13)}},
            })
          }
        }
      })
    }

  };
  
  // Render the active baseplate based on
  // the index value of arrows
  _renderActiveSelectable = (direction, type) => {

    // If a user makes any change in the selection. Warn him about the leaving the
    // app i.e. that the progress will be lost.
    window.addEventListener('beforeunload', this._handleLeavePage);


    //Not 0 items refer to the amount of the product variations
    if (this.state.lockMode && type !== 'baseplate') {
      this.setState(prevState => {
        const newPocketSmall = prevState.activePocketSmall;
        const newPocketMedium= prevState.activePocketMedium;
        const newPocketBig = prevState.activePocketBig;
        const newCord = prevState.activeCord;
        const newLoop = prevState.activeLoop;

        if (direction === 'next') {
          return {
            activeCord: prevState.activeCord >= this.state.products[1].variants.length - 1 ? 0 : newCord + 1,
            activePocketSmall: prevState.activePocketSmall >= this.state.products[2].variants.length - 1 ? 0 : newPocketSmall + 1,
            activePocketMedium: prevState.activePocketMedium >= this.state.products[3].variants.length - 1 ? 0 : newPocketMedium + 1,
            activePocketBig: prevState.activePocketBig >= this.state.products[4].variants.length - 1 ? 0 : newPocketBig + 1,
            activeLoop: prevState.activeLoop >= this.state.products[5].variants.length - 1 ? 0 : newLoop + 1,
          };
        }
  
        else if (direction === 'prev') {
          return {
            activeCord: prevState.activeCord === 0 ? this.state.products[1].variants.length - 1 : newCord - 1,
            activePocketSmall: prevState.activePocketSmall === 0 ? this.state.products[2].variants.length - 1 : newPocketSmall - 1,
            activePocketMedium: prevState.activePocketMedium === 0 ? this.state.products[3].variants.length - 1 : newPocketMedium - 1,
            activePocketBig: prevState.activePocketBig === 0 ? this.state.products[4].variants.length - 1 : newPocketBig - 1,
            activeLoop: prevState.activeLoop === 0 ? this.state.products[5].variants.length - 1 : newLoop - 1,
          };
        }
      })
    }

    else {

      if (type === 'baseplate') {
        this.setState(prevState => {  
          const newValue = prevState.activeBaseplate;
    
          if (direction === 'next') {
            return {
              activeBaseplate: prevState.activeBaseplate >= this.state.products[0].variants.length - 1 ? 0 : newValue + 1,
            };
          }
    
          else if (direction === 'prev') {
            return {
              activeBaseplate: prevState.activeBaseplate === 0 ? this.state.products[0].variants.length - 1 : newValue - 1,
            };
          }
        })  
      }
  
      else if (type === 'fastening-cord') {
        this.setState(prevState => {  
          const newValue = prevState.activeCord;
    
          if (direction === 'next') {
            return {
              activeCord: prevState.activeCord >= this.state.products[1].variants.length - 1 ? 0 : newValue + 1,
            };
          }
    
          else if (direction === 'prev') {
            return {
              activeCord: prevState.activeCord === 0 ? this.state.products[1].variants.length - 1 : newValue - 1,
            };
          }
        })  
      }
  
      else if (type === 'pocket-s' || type === 'pocket-m' || type === 'pocket-l' || type === 'pocket-xl' || type === 'pocket-xxl' || type === 'pocket-b' || type === 'outbag-5-5' || type === 'outbag-9-5' || type === 'laundrygg') {
        this.setState(prevState => {  
          const newValue = prevState.activePocketMode;
    
          if (direction === 'next') {
            return {
              activePocketMode: prevState.activePocketMode >= dataPockets.length - 1 ? 0 : newValue + 1,
            };
          }
    
          else if (direction === 'prev') {
            return {
              activePocketMode: prevState.activePocketMode === 0 ? dataPockets.length - 1 : newValue - 1,
            };
          }
        })  
      }
  
      else if (type === 'single-hook' || type === 'double-hook' || type === 'loop' || type === 'paper-roll-holder' ) {
        this.setState(prevState => {  
          const newValue = prevState.activeHookMode;
    
          if (direction === 'next') {
            return {
              activeHookMode: prevState.activeHookMode >= dataHooks.length - 1 ? 0 : newValue + 1,
            };
          }
    
          else if (direction === 'prev') {
            return {
              activeHookMode: prevState.activeHookMode === 0 ? dataHooks.length - 1 : newValue - 1,
            };
          }
        })  
      }
    }
  }

  _clearRenderedProducts = () => {
    const { activeInitialBaseplate } = this.state;
    if (activeInitialBaseplate === '4x2') {
      this.setState({
        cells_4x2 : update(this.state.cells_4x2, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '10x3') {
      this.setState({
        cells_10x3 : update(this.state.cells_10x3, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
          12: {available: {$set: true}},
          13: {available: {$set: true}},
          14: {available: {$set: true}},
          15: {available: {$set: true}},
          16: {available: {$set: true}},
          17: {available: {$set: true}},
          18: {available: {$set: true}},
          19: {available: {$set: true}},
          20: {available: {$set: true}},
          21: {available: {$set: true}},
          22: {available: {$set: true}},
          23: {available: {$set: true}},
          24: {available: {$set: true}},
          25: {available: {$set: true}},
          26: {available: {$set: true}},
          27: {available: {$set: true}},
          28: {available: {$set: true}},
          29: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '10x2_KOMPANJA') {
      this.setState({    
        cells_10x2_KOMPANJA : update(this.state.cells_10x2_KOMPANJA, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
          12: {available: {$set: true}},
          13: {available: {$set: true}},
          14: {available: {$set: true}},
          15: {available: {$set: true}},
          16: {available: {$set: true}},
          17: {available: {$set: true}},
          18: {available: {$set: true}},
          19: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '8x1') {
      this.setState({
        cells_8x1 : update(this.state.cells_8x1, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '8x2') {
      this.setState({
        cells_8x2 : update(this.state.cells_8x2, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
          12: {available: {$set: true}},
          13: {available: {$set: true}},
          14: {available: {$set: true}},
          15: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '6x2') {
      this.setState({
        cells_6x2: update(this.state.cells_6x2, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '2x2') {
      this.setState({
        cells_2x2 : update(this.state.cells_2x2, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '2x3') {
      this.setState({
        cells_2x3 : update(this.state.cells_2x3, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '2x4') {
      this.setState({
        cells_2x4 : update(this.state.cells_2x4, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '12x1') {
      this.setState({
        cells_12x1 : update(this.state.cells_12x1, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '4x4') {
      this.setState({
        cells_4x4 : update(this.state.cells_4x4, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
          12: {available: {$set: true}},
          13: {available: {$set: true}},
          14: {available: {$set: true}},
          15: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '4x3') {
      this.setState({
        cells_4x3 : update(this.state.cells_4x3, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
        }),
      })
    }

    else if (activeInitialBaseplate === '4x2') {
      this.setState({
        cells_4x2 : update(this.state.cells_4x2, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
        }),
      })
    }

    else {
      this.setState({
        cells : update(this.state.cells, {
          0: {available: {$set: true}},
          1: {available: {$set: true}},
          2: {available: {$set: true}},
          3: {available: {$set: true}},
          4: {available: {$set: true}},
          5: {available: {$set: true}},
          6: {available: {$set: true}},
          7: {available: {$set: true}},
          8: {available: {$set: true}},
          9: {available: {$set: true}},
          10: {available: {$set: true}},
          11: {available: {$set: true}},
          12: {available: {$set: true}},
          13: {available: {$set: true}},
          14: {available: {$set: true}},
          15: {available: {$set: true}},
          16: {available: {$set: true}},
          17: {available: {$set: true}},
        }),
      })
    }

    this.setState({
      addedProducts: [],
      cartProducts:[],
      cartTotalPrice: 0.00
    })
  }

  _dropToRemoveSingleRendered = (product) => {
    const {id} = product.productDetails;
    const {startCell, endCell, type} = product.productDetails.productDetails;
    
    this.setState(prevState => {
     return {
      cartTotalPrice: prevState.cartTotalPrice - parseFloat(prevState.addedProducts[id].price),
      addedProducts : update(this.state.addedProducts, {
        $splice: [[id, 1]]
      }),

      cartProducts : update(this.state.cartProducts, {
        $splice: [[id, 1]]
      })
     }
    })

    // Make the removed item's cells available now
    this._updateCellUnavailability(startCell, endCell, type);

  }

  _checkout = () => {
    window.removeEventListener('beforeunload', this._handleLeavePage);
    const { activeInitialBaseplate, showBaseplateSelectionControls, isWallBaseplate, addAdhesiveScrewSet, addWashersAndScrews } = this.state;

    this.setState({
      checkoutLoading: true
    })
    // Create an empty checkout
    client.checkout.create().then((checkout) => {
      const mandatoryProductsSeat = [
        // Active Baseplate
        {
          quantity: 1,
          variantId: this.state.products[
            activeInitialBaseplate === '10x3' ? 11 : 0
          ].variants[this.state.activeBaseplate].id
        },

        // Active Cord
        {
          quantity: 1,
          variantId: this.state.products[
            activeInitialBaseplate === '10x3' ? 10 : 1
          ].variants[this.state.activeCord].id
        }
      ]

      let mandatoryProductsWall = [
        // Active Baseplate
        {
          quantity: 1,
          variantId: this.state.products[
            activeInitialBaseplate === '10x3' ? 11 :
            activeInitialBaseplate === '4x4' ? 13 :
            activeInitialBaseplate === '4x3' ? 14 :
            activeInitialBaseplate === '4x2' ? 15 :
            activeInitialBaseplate === '12x1' ? 16 :
            activeInitialBaseplate === '8x1' ? 17 :
            activeInitialBaseplate === '8x2' ? 18 :
            activeInitialBaseplate === '10x3' ? 19 :
            activeInitialBaseplate === '2x2' ? 20 :
            activeInitialBaseplate === '2x3' ? 21 :
            activeInitialBaseplate === '2x4' ? 22 :
            activeInitialBaseplate === '6x2' ? 23 :
            activeInitialBaseplate === '6x3' ? 24 :
            0
          ].variants[this.state.activeBaseplate].id
        },
      ]

      if (addWashersAndScrews) {
        const washersAndScrewsID = this.state.products[25].variants[0].id
        mandatoryProductsWall.push({
          quantity:(activeInitialBaseplate === '12x1' || 
          activeInitialBaseplate === '8x1' || 
          activeInitialBaseplate === '8x2' || 
          activeInitialBaseplate === '10x2_KOMPANJA' || 
          activeInitialBaseplate === '10x3') ? 3 : 2,
          variantId: washersAndScrewsID
        });
      }

      if (addAdhesiveScrewSet) {
        const adhesiveScrewSetID = this.state.products[26].variants[
          (activeInitialBaseplate === '12x1' || 
          activeInitialBaseplate === '8x1' || 
          activeInitialBaseplate === '8x2' || 
          activeInitialBaseplate === '10x2_KOMPANJA' || 
          activeInitialBaseplate === '10x3') ? 1 : 0
        ].id
        mandatoryProductsWall.push({
          quantity: 1,
          variantId: adhesiveScrewSetID
        })
      }

      const mandatoryProducts = isWallBaseplate ? mandatoryProductsWall : mandatoryProductsSeat

      // Did it this way because otherwise the card would end up being empty

      // If baseplate selection is open on kompanja baseplate. It means the baseplate price and product is added,ss
      if (activeInitialBaseplate === '10x2_KOMPANJA' && showBaseplateSelectionControls) {
        client.checkout.addLineItems(checkout.id, [{
          quantity: 1,
          variantId: this.state.products[12].variants[this.state.activeBaseplate].id
        }].concat(this.state.cartProducts)).then((checkout) => {
          client.checkout.fetch(checkout.id).then((checkout) => {
            // Open the chekout link
            window.location.href = checkout.webUrl
          });
        });
      }

      // If baseplate selection is not open, then don't add baseplate, but only products.
      else if (activeInitialBaseplate === '10x2_KOMPANJA') {
         // Add items to the checkout
        client.checkout.addLineItems(checkout.id, this.state.cartProducts).then((checkout) => {
          client.checkout.fetch(checkout.id).then((checkout) => {
            // Open the chekout link
            window.location.href = checkout.webUrl
          });
        });
      }

      else {
        // Add items to the checkout
        client.checkout.addLineItems(checkout.id, mandatoryProducts.concat(this.state.cartProducts)).then((checkout) => {
          client.checkout.fetch(checkout.id).then((checkout) => {
            // Open the chekout link
            window.location.href = checkout.webUrl
          });
        });
      }
    });
  }

  _handleLeavePage(e) {
    const confirmationMessage = 'Changes you made may not be saved.';
    e.returnValue = confirmationMessage;  // Gecko, Trident, Chrome 34+
    return confirmationMessage;           // Gecko, WebKit, Chrome <34
  }

  _generateCode = () => {
    this.setState({
      generatedCode: JSON.stringify(this.state.addedProducts)  
    })
  }

  _setInitialBaseplate = (id, isWallBaseplate) => {
    window.scrollTo(0,0);
    
    this.setState({
      activeInitialBaseplate: id,
      showBaseplateSelectionControls: true,
      isWallBaseplate: isWallBaseplate
    })
  }

	render() {
    const { 
      activeBaseplate, 
      stringData, 
      activeInitialBaseplate, 
      isWallBaseplate,
      cells_10x3, 
      cells_10x2_KOMPANJA, 
      cells_8x1, 
      cells_8x2, 
      cells_6x2,
      cells_2x2,
      cells_2x3,
      cells_2x4,
      cells_12x1,
      cells_4x4,
      cells_4x3,
      cells_4x2,
      addAdhesiveScrewSet,
      addWashersAndScrews,
      cells } = this.state;

    const washersAndScrewsQty = (activeInitialBaseplate === '12x1' || 
      activeInitialBaseplate === '8x1' || 
      activeInitialBaseplate === '8x2' || 
      activeInitialBaseplate === '10x2_KOMPANJA' || 
      activeInitialBaseplate === '10x3') ? 3 : 2
      
    return (
      <div className="site-container">
      {/* <div className="header-alert">
        <a href="https://vantale.de/collections/ryggs-lagerbestands-check">
        <p>LAGER FAST LEER - Bei konfigurierten RYGGs beträgt die Lieferzeit gerade 1-4 Wochen. Alle Infos zum Lagerbestand und den aktuellen Lieferzeiten gibt es hier.</p>
        </a>
      </div> */}
      {window.innerWidth >= 1024 &&
        <div className="site-container-inner">
                
        <Header 
          title={stringData.string_0}
          stringData={stringData} 
          activeInitialBaseplate={this.state.activeInitialBaseplate} 

          resetActiveBaseplateState={() => { 
            this.setState({activeInitialBaseplate: null});

            // IMPORTANT TODO: Check this function
            this._clearRenderedProducts()
          }}
        />
         {/* <a className="logo-container" href="https://vantale.de/">
          <img className="logo large-screen" src={logo} alt="Logo" />
          <img className="logo small-screen" src={logoMobile} alt="Logo" />
         </a> */}
          <Modal 
            stringData={stringData.string_9}
            // show={this.state.isOpen}
            show={false}
            onClose={this.toggleModal}>
            <div className="header">
              <h5>{stringData.string_1}</h5>
              <p>{stringData.string_2}</p>
            </div>
  
            <div className="video-container">
            <Vimeo
              width="600px"
              video="305369078"
            />
            </div>
  
            <div className="info">
              <img src={information} alt="Information" />
              <p>
                {stringData.string_3}
              </p>
            </div>
  
            <div className="details">
              <h5>{stringData.string_4}</h5>
              <ul>
                <li><img src={check} alt="Check" />{stringData.string_5}</li>
                <li><img src={check} alt="Check"/>{stringData.string_6}</li>
                <li><img src={check} alt="Check"/>{stringData.string_7}</li>
              </ul>
  
              {this.state.activeLanguage === 'english' &&
                <p className="disclaimer">
                  If you need additional modules please visit our <a target="_blank" href="https://vantale.de/pages/single-modules" rel="noopener noreferrer">Single Modules</a> (opens new tab) section.
                </p>
              }

              {this.state.activeLanguage === 'german' &&
                <p className="disclaimer">
                  Wenn du zusätzliche Module benötigst, findest du hier alle <a target="_blank" href="https://vantale.de/pages/single-modules" rel="noopener noreferrer">einzelne Produkte</a>. (öffnet ein neues Tab).
                </p>
              }
            </div>
          </Modal>
          <ModalBeforeCheckout 
            show={this.state.showBeforeCheckoutModal}
            onClose={this.toggleBeforeCheckoutModal}>
            <div className="header">
              <h5>{stringData.string_35} <span>{stringData.string_46}</span>?</h5>
              <p>{stringData.string_36}</p>
            </div>
  
            <div className="body">
              <div className="section-text">
                <h6>{stringData.string_37}</h6>
                <p><a target="_blank" href="https://vantale-store.de/pages/wall-rygg-baseplates-overview">{stringData.string_38}</a></p>
              </div>
              <div className="row-items-container">
                <div className="row-item">
                  <div className="thumb">
                    <img src={washersScrewSet}/>
                  </div>
                </div>
                <div className="row-item">
                  <h6>{stringData.string_40}</h6>
                  <p className="qty">
                    {
                      (activeInitialBaseplate === '12x1' || 
                      activeInitialBaseplate === '8x1' || 
                      activeInitialBaseplate === '8x2' || 
                      activeInitialBaseplate === '10x2_KOMPANJA' || 
                      activeInitialBaseplate === '10x3') ? '6x' : '4x'
                    }
                  </p>
                  <p>{stringData.string_41}</p> 
                </div>
                <div className="row-item">
                  <h6 className="price">{stringData.string_44} €{(0.45 * washersAndScrewsQty).toFixed(2)}</h6>
                  <div className="btn-container">
                    <button className={`btn ${this.state.addWashersAndScrews ? 'active':''}`} onClick={() => this.setState({addWashersAndScrews: !this.state.addWashersAndScrews})}>
                      <span><img src={plus} /> {stringData.string_42}</span>
                      <span><img src={checkGreen} /> {stringData.string_43}</span>
                    </button>
                  </div>
                </div>    
              </div>

              <div className="section-text">
                <h6>{stringData.string_39}</h6>
                <p><a target="_blank" href="https://vantale-store.de/pages/wall-rygg-baseplates-overview">{stringData.string_38}</a></p>
              </div>
              <div className="row-items-container">
                <div className="row-item">
                  <div className="thumb">
                    <img src={
                      (activeInitialBaseplate === '12x1' || 
                      activeInitialBaseplate === '8x1' || 
                      activeInitialBaseplate === '8x2' || 
                      activeInitialBaseplate === '10x2_KOMPANJA' || 
                      activeInitialBaseplate === '10x3') ? adhesiveScrewSet6 : adhesiveScrewSet4
                    }/>
                  </div>
                </div>
                <div className="row-item">
                  <h6>{stringData.string_40}</h6>
                  <p className="qty">1x</p>
                  <p>{stringData.string_41}</p>
                </div>
                <div className="row-item">
                  <h6 className="price">{stringData.string_44} €{ (activeInitialBaseplate === '12x1' || 
                      activeInitialBaseplate === '8x1' || 
                      activeInitialBaseplate === '8x2' || 
                      activeInitialBaseplate === '10x2_KOMPANJA' || 
                      activeInitialBaseplate === '10x3') ? '34.40' : '22.60'}</h6>
                  <div className="btn-container">
                    <button className={`btn ${this.state.addAdhesiveScrewSet ? 'active':''}`} onClick={() => this.setState({addAdhesiveScrewSet: !this.state.addAdhesiveScrewSet})}>
                      <span><img src={plus} /> {stringData.string_42}</span>
                      <span><img src={checkGreen} /> {stringData.string_43}</span>
                    </button>
                  </div>
                </div>    
              </div>

              <div className="footer">
                <button disabled={this.state.checkoutLoading || this.state.products.length < 1} className={`btn btn-checkout ${this.state.checkoutLoading ? 'loading': null }`} onClick={() => this._checkout()}>
                  <img src={Loading} alt="Loading" />
                  <span>{stringData.string_45}</span>
                </button>
              </div>
            </div>
          </ModalBeforeCheckout>

          {!this.state.activeInitialBaseplate && false &&
            <InitialBaseplateSelection 
              appState={this.state}
              setInitialBaseplate={this._setInitialBaseplate}
            />
          }
          
          <div className={`
            container 
            ${
              (activeInitialBaseplate === '10x3' || activeInitialBaseplate === '10x2_KOMPANJA' || activeInitialBaseplate === '12x1') ? 'wide':
              (activeInitialBaseplate === '8x1' || activeInitialBaseplate === '8x2') ? 'medium' :
              ''
            }
          `}>

            <div className={`app ${this.state.isOpen ? 'blurred-not': ''}`}>
              <div className="configurator">
                <div className="workbench-container">
                  <div className="inside-header">
                    <h2>Module</h2>
                  </div>
                
                  <div className="selections">
                    {this.state.productsLoading && 
                      <div className="loading-icon">
                      <img src={loadingDark} alt="Loading"/>
                      <h5>Loading your experience...</h5>
                    </div>
                    }
                    {/* {this._renderAPISelectableProducts(this.state.products)} */}
                    {this._renderAPIDraggableProducts(this.state.products)}
                    
                    <DropToRemove 
                      visible={this.state.canDelete}
                      appState={this.state}
                      dropToRemoveSingleRendered={this._dropToRemoveSingleRendered}
                    />
                  </div>
                </div>
                {/* style={{backgroundImage: `url(${backgroundTexture})`}} */}
                <div className="result-container" >
                  <div className="inside-header">
                    <h2>Deine Basisplatte</h2>
                    <div className="steps">
                      <div className="inner">
                        <img src={steps} />
                      </div>
                      <p>{stringData.string_52}</p>
                    </div>
                  </div>
                  
                  <div className={`baseplate ${this.state.hasHaube && 'has-haube'} _${activeInitialBaseplate} ${isWallBaseplate ? 'wall-baseplate':''}`}>
                    {this.state.hasHaube && <img className="baseplate-svg" src={baseplateExtended} />}
                    {this._renderCells(
                      activeInitialBaseplate === '4x2' ? cells_4x2 : 
                      activeInitialBaseplate === '10x3' ? cells_10x3 :
                      activeInitialBaseplate === '10x2_KOMPANJA' ? cells_10x2_KOMPANJA :
                      activeInitialBaseplate === '8x1' ? cells_8x1 :
                      activeInitialBaseplate === '8x2' ? cells_8x2 :
                      activeInitialBaseplate === '6x2' ? cells_6x2 :
                      activeInitialBaseplate === '2x2' ? cells_2x2 :
                      activeInitialBaseplate === '2x3' ? cells_2x3 :
                      activeInitialBaseplate === '2x4' ? cells_2x4 :
                      activeInitialBaseplate === '12x1' ? cells_12x1 :
                      activeInitialBaseplate === '4x4' ? cells_4x4 :
                      activeInitialBaseplate === '4x3' ? cells_4x3 :
                      activeInitialBaseplate === '4x2' ? cells_4x2 :
                      cells
                    )}

                    {this._renderAddedProducts(this.state.addedProducts)}
                    
                    {!isWallBaseplate ? (activeInitialBaseplate === '10x3' ? 
                      (
                        <div>
                          <div className="plug-big double-baseplate top _1"></div>
                          <div className="plug-big double-baseplate top _2"></div>
                          <div className="plug-big double-baseplate top _3"></div>
                          <div className="plug-big double-baseplate top _4"></div>
                          <div className="plug-big double-baseplate bottom _1"></div>
                          <div className="plug-big double-baseplate bottom _2"></div>
                          <div className="plug-big double-baseplate bottom _3"></div>
                          <div className="plug-big double-baseplate bottom _4"></div>
                        </div>
                      )
                      : <div>
                        <div className="plug-big top left"></div>
                        <div className="plug-big top right"></div>
                        <div className="plug-big bottom left"></div>
                        <div className="plug-big bottom right"></div>
                      </div>
                    
                    ) :
                    <div>
                      <div className="hole top left"></div>

                      {(activeInitialBaseplate === '8x1' || activeInitialBaseplate === '8x2' || activeInitialBaseplate === '10x2_KOMPANJA' || activeInitialBaseplate === '10x3') &&
                        <div className="hole top center"></div>
                      }

                      {activeInitialBaseplate === '12x1' &&
                        <>
                          <div className="hole top middle-left"></div>
                          <div className="hole top middle-right"></div>
                        </>
                      }

                      <div className="hole top right"></div>
                      <div className="hole bottom left"></div>
                      <div className="hole bottom right"></div>
                    </div>
                    }
                  </div>
                  
                  {/* {!this.state.isWallBaseplate &&
                    <ActiveCord activeCord={this.state.activeCord}/>
                  } */}
                </div>
                    
                <Sidebar
                  activeLanguage={this.state.activeLanguage}
                  stringData={stringData} 
                  products={this.state.products}
                  isCreator={this.state.isCreator}
                  generateCode={this._generateCode} 
                  generatedCode={this.state.generatedCode}
                  activeBaseplate={this.state.activeBaseplate}
                  showBaseplateSelectionControls={this.state.showBaseplateSelectionControls}
                  activeInitialBaseplate={this.state.activeInitialBaseplate}
                  isWallBaseplate={this.state.isWallBaseplate}
                  activeCord={this.state.activeCord}
                  addedProducts={this.state.addedProducts}
                  clearRenderedProducts={this._clearRenderedProducts}
                  checkout={this._checkout} 
                  beforeCheckout={() => this.setState({showBeforeCheckoutModal: true})}
                  cartTotalPrice={this.state.cartTotalPrice}
                  checkoutLoading={this.state.checkoutLoading}
                />
              </div>
            </div>
            {/* <FooterLinks activeLanguage={this.state.activeLanguage} stringData={this.state.stringData} /> */}
          </div>
         </div>
      }

      {window.innerWidth < 1024 &&
        <div className="not-supported">
          <div className="inner">
            <div className="logo-mobile">
              <img src={logoMobile} alt="Logo"/>
            </div>
            {this.state.activeLanguage === 'german' && 
              <div>
                <h5>Dein Gerät ist zu klein!</h5>
                <p>Die Nutzung des Konfigurators ist auf deinem aktuellen Gerät nicht möglich.</p>
                <p>Bitte wechsle zu einem Desktop-Computer oder einem Tablet oder schau dich in <a href="https://vantale.de/">unserem Shop</a> um.</p>
              </div>
            }

            {this.state.activeLanguage === 'english' && 
              <div>
                <h5>Not Supported</h5>
                <p>Your current device does not support the Customizer.</p>
                <p>Please switch to a desktop, or proceed to browsing our <a href="https://vantale.de/">online store</a></p>
              </div>
            }
            <FooterLinks activeLanguage={this.state.activeLanguage} stringData={this.state.stringData} />
          </div>
        </div>
      }
      </div>
    );
  }
}

export default DragDropContext(MultiBackend(HTML5toTouch))(App)

// This is a working backbone of the preconfigured product functionality
// console.log('====================================')
// // initial string
// var originalJson = [{"abc": "aaa"},{"def": "sss"},{"ghi": 3232}];
// var originalJsonPrepared = '';
// originalJson.map((product, id) =>{
//   originalJsonPrepared += JSON.stringify(product) + (id === originalJson.length - 1 ? '' : '&')
// })

// console.log(originalJsonPrepared)

// console.log('----------------------------------')

// var arrStr = originalJsonPrepared.split(/[&]/);
// var finalArrayString = "";
// var finalArray = []

// for(var i=0; i<arrStr.length; i++) {
//   console.log(arrStr[i]);
//   finalArrayString += arrStr[i] + ",";
//   finalArray.push(JSON.parse(arrStr[i]))
// }
// console.log(finalArray);